webpackJsonp([1],{

/***/ "1xcZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3fk6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BL8g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BNiI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C3XE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7007daf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("C3XE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25a07e32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("1xcZ")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-212a0afc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("loeG")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-212a0afc"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f0bb17a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("BL8g")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-9f0bb17a"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6f8c210","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}),0)]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("tATK")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-b6f8c210"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e63bb88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("mLy2")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3233e303","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}),0)])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("n9S7")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ab0e8b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}),0)])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("y5zj")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3738d1d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){return _vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("lGnO")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e37519de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("ZZuH")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f2bd431","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("d/CA")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ce90240","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){return _vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){return _vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()}),0):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("dTE+")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60a0c009","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}),1):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}),1)])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("oEyU")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f17fad4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){return _vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])}),0),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("icNF")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0693ed8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return null}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28207f05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}),0)}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("gck0")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6778dfcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("BNiI")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9ef5fee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}),0)],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("gqD2")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-c9ef5fee"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413a4779","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("yREt")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fff93bc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("tki5")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f84e89","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("3fk6")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Olympic Review - Issue 122",
  "shortTitle": "",
  "description": "",
  "width": 719,
  "height": 890,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://olympicreview.touchlines.com/122"
  }, {
    "code": "FR",
    "text": "French",
    "href": "http://revueolympique.touchlines.com/122"
  }],
  "basePath": "/122",
  // "basePath": " ",
  "companyLogo": "1-logo-1.png",
  "publishURL": "http://olympic-review.s3-website-eu-west-1.amazonaws.com/122/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,

    "content": "\n        <img class=\"halfScale 1-head\" style=\"top:4px;left:1px\" src=\"/122/static/_content/1-title-1.png\"/>\n        <img class=\"halfScale 1-title\" style=\"top:155px;left:255px\" src=\"/122/static/_content/1-title-2.png\"/>\n        <img class=\"halfScale 1-title\" style=\"top:15px;left:240px\" src=\"/122/static/_content/1-title-3.png\"/>\n        <img class=\"halfScale 1-title\" style=\"top:162px;left:532px\" src=\"/122/static/_content/1-title-4.png\"/>\n\n        <img class=\"halfScale 1-sub\" style=\"top:224px;left:33px\" src=\"/122/static/_content/1-sub-1.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:305px;left:33px\" src=\"/122/static/_content/1-sub-2.png\"/>\n\n        <img class=\"halfScale 1-sub\" style=\"top:226px;left:545px\" src=\"/122/static/_content/1-sub-3.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:269px;left:545px\" src=\"/122/static/_content/1-line-1.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:283px;left:545px\" src=\"/122/static/_content/1-sub-4.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:327px;left:545px\" src=\"/122/static/_content/1-line-2.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:341px;left:545px\" src=\"/122/static/_content/1-sub-5.png\"/>\n\n        <img id=\"1-logo-1\" class=\"halfScaleC\" style=\"top:812px;left:-27px\" src=\"/122/static/_content/1-logo-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:860px;left:626px;height:16px;width:82px;\">\n          <a href=\"https://olympics.com/\" target=\"_blank\"></a>\n        </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim\n            .fromTo(cOf(\"1-head\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n            .staggerFromTo(cOf(\"1-title\"), 0.6, {opacity:0, y:50},{opacity:1, y:0, ease: Power2.easeOut}, 0.3, 1.3)\n            .staggerFromTo(cOf(\"1-sub\"), 0.4, {opacity:0, x:30},{opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1.9)\n            .fromTo(idOf(\"1-logo-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\", 1)\n            .fromTo(cOf(\"1-link\"), 0.6, {opacity:0, x:-40},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 3.6)\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Official Publication of the Olympic Movement  TM  REVIEW  A French Summer Paris 2024 will unite the world in a celebration of sport  June 2024 Number 122  How Paris 2024 is setting new standards for major sports events French sporting icons reveal what it means to host the Games Leading journalists share their views on the athletes to follow at the Games  olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <img id=\"4-title-1\" class=\"halfScale\" style=\"top:114px;left:43px\" src=\"/122/static/_content/4-title-1.png\"/>\n        <img id=\"4-sub-1\" class=\"halfScale\" style=\"top:178px;left:43px\" src=\"/122/static/_content/4-sub-1.png\"/>\n\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(6)\" style=\"top:369px;left:51px;width:83px;height:90px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(8)\" style=\"top:693px;left:49px;width:265px;height:137px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(22)\" style=\"top:236px;left:222px;width:125px;height:186px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(36)\" style=\"top:487px;left:348px;width:135px;height:132px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(40)\" style=\"top:726px;left:529px;width:151px;height:125px\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.fromTo(idOf(\"4-title-1\"), 0.8, {opacity:0, y:-40},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"4-sub-1\"), 0.4, {opacity:0, x:-40},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n          pg4Anim.kill();\n      }\n      ",
    "searchText": "4  Contents  CONTENTS  OFFICIAL PUBLICATION OF THE OLYMPIC MOVEMENT JUNE 2024  22  PARIS 2024: THE SPORTING LEGACY  6  FOREWORD  While Paris 2024 will be a celebration of elite sport, the success of the Games will also be judged on the impact on local communities. Nicolas Pecherot explains how the French public will benefit from the Games.  By IOC President Thomas Bach.  36  EMBRACING THE URBAN SPIRIT Explore how this edition of the Games will bring dynamism and innovation to the world through its youth-focused programme.  8  A VIRTUOUS CIRCLE  As Paris 2024 puts sustainability at the heart of its planning, Olympic Review explores how the Games could serve as a foundation for a new social and circular business model for other event organisers to follow in the future.  40  OLYMPISM WITH A FRENCH FLAVOUR Alain Mercier speaks with French Olympians Laura Flessel, Romane Dicko and Alain Bernard about their relationship with the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(48)\" style=\"top:204px;left:181px;width:111px;height:137px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(54)\" style=\"top:298px;left:326px;width:131px;height:99px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(68)\" style=\"top:498px; left:306px; width:147px; height:136px;\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(76)\" style=\"top:688px;left:52px;width:105px;height:166px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(80)\" style=\"top:748px;left:169px;width:93px;height:105px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(82)\" style=\"top:748px;left:279px;width:128px;height:105px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(84)\" style=\"top:748px;left:419px;width:87px;height:105px\"></div>\n\n\n        <div class=\"addContentLinkThree\" style=\"top:602px;left:530px;height:10px;width:104px;\">\n          <a href=\"https://www.olympics.com/ioc\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLinkThree\" style=\"top:612px;left:530px;height:10px;width:110px;\">\n          <a href=\"mailto:olympicreview@olympic.org\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },2000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": "Olympic Review  5  Issue 122  EXECUTIVE BOARD President Thomas Bach Vice-Presidents John D. Coates AC, Ser Miang Ng, Nicole Hoevertsz, Juan Antonio Samaranch Members Robin E. Mitchell, Denis Oswald, Nenad Lalovic, Ivo Ferriani, Prince Feisal Al Hussein, Mikaela Cojuangco Jaworski, Gerardo Werthein, Kristin Kloster, Emma Terho, Kirsty Coventry  48  OLYMPIC REVIEW  A UNIQUE PATH TO PARIS  Olympic Review looks at the stories of athletes who have received Olympic Solidarity scholarships on their journeys to the Games.  54  THROUGH THE LENS  A pictorial look at the iconic French landmarks that will host events at the Games.  Corporate Communications & Public Affairs Director Christian Klaue Editor-in-Chief Katharine Mann Deputy Editor & French Edition Lucile Tonnerre Spanish Edition Dolores Blázquez Production Agency Touchline Production Michael Stoneman, Glyn Wilmshurst, John Murray, Sam Price, Conor Ketley Design Liz Rankin, Shyama Rajani, Apostolis Tatasopoulos Image retouching Liz Rankin Translation Aurélien Sagnier, Héctor López Conceiro, José-Luis Pérez Morais Proofreading Fréderic Brunet ISSN: 0377-192X Printed in the UK  IMAGES Cover image: Paris 2024/BOBY Inside: IOC; IOC/Greg Martin; IOC/John Huet; IOC/Giulio Locatelli; Getty Images; Paris 2024 Organising Committee for the Olympic and Paralympic Games; Paris 2024/Cédric Michel; Paris 2024/Bastien Eveno; Paris 2024/Antoine Guilloteau; Paris 2024/Benjamin Boccas; Paris 2024/Jean Ratsimbazafy; Paris 2024/Sarah Witt; Paris 2024/Matthew Oliver; Paris 2024/Guillaume Ruchaud; Paris 2024/Anthony Dorfmann; Paris 2024/BOBY; Roxane Montaron/Les Canaux; Alain Bernard; Edda Hannesdóttir; Tasi Limtiaco; World Triathlon; Shutterstock; Unsplash  68  ONES TO WATCH  As athletes gather to make Olympic history, sports journalists Alexandre Boyon, Wakako Yuki and Karen Rosen pick out the most exciting stories that could unfold.  CONTACTS Please send your letters to: Olympic Review, IOC Corporate Communications & Public Affairs Department, Maison Olympique, 1007 Lausanne, Switzerland website: www.olympics.com/ioc email: olympicreview@olympic.org tel: +41 (0)21 621 6111  76  THE COLOSSAL LEGACY OF A FORGOTTEN HERO  George Hirthler examines the ongoing influence of the man who launched the modern Olympic Games - Baron Pierre de Coubertin.  80  82  84  Book reviews from the IOC Olympic Studies Centre.  Olympians and figures from the Olympic Movement who have passed away.  How Paris 2024 is delivering on sustainability.  OLYMPIC STUDIES  OBITUARIES  THE LAST WORD  Olympic Review is published by the International Olympic Committee. The articles published in Olympic Review do not necessarily reflect the opinions of the International Olympic Committee. No articles may be reproduced without the permission of the IOC Corporate Communications & Public Affairs Department. The Olympic terminology (in particular Olympic™, Olympics™ and Olympic Games™) and other Olympic Properties are registered trademarks (TM) owned by the IOC. For further information on the protection of the Olympic Properties, please consult the website: olympics.com.  All information correct at the time of going to press  Olympic Review uses PEFC-certified paper stock sourced from sustainably managed forests."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img id=\"6-title-1\" class=\"halfScale\" style=\"top:178px;left:43px\" src=\"/122/static/_content/6-title-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:619px; left:349px; width:108px; height:14px;\">\n          <a href=\"https://olympics.com/ioc/olympic-agenda-2020\" target=\"_blank\"></a>\n        </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim.fromTo(idOf(\"6-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n          removeContentLinks();\n      }\n      ",
    "searchText": "6  Foreword  1  FOREWORD BY THOMAS BACH A  1 Paris is dressing up in its ﬁnest Olympic attire to welcome the athletes and the public this summer.  s France welcomes the world to the Olympic Games Paris 2024, the excitement is palpable. At a time when humanity is more divided than ever, this display of unity is eagerly anticipated. All the signs are there that this edition of the Olympic Games will live up to its slogan, 'Games Wide Open', not least as spectators are able to return to the Games once more. When the athletes from the territories of the National Olympic Committees around the globe and the IOC Refugee Olympic Team come together in Paris, they will send an inspiring message of peace, solidarity and unity of all humankind in all our diversity. The stage is set for the athletes to shine and show the world what greatness humans are capable of when we come together in peaceful competition Paris 2024 is the ﬁrst Olympic Games to be organised under Olympic Agenda 2020 from start to ﬁnish. The Games will be more inclusive, more sustainable, more urban and more youthful. For the ﬁrst time at an Olympic Games, full gender parity will be achieved on the ﬁeld of play because the IOC allocated 50 per cent of places to women and 50 per cent to men. Iconic Parisian landmarks will be transformed into competition venues, bringing sport into the heart of the city where the people are. The public can take part in sports events, such as the Marathon Pour Tous, when over 40,000 runners will run the same marathon route that the Olympic athletes compete on. Meanwhile, some of the recently added sports on the programme - among  them breaking, sport climbing and skateboarding - have tremendous youth appeal and are generating excitement among the younger demographic. Thanks to the tireless efforts of the Organising Committee, Paris 2024 is also setting new standards when it comes to sustainability. Some 95 per cent of venues for the Games are either existing or temporary, while carbon emissions will be limited to about half of those of the Olympic Games London 2012 and Rio 2016. This philosophy has carried over into other areas of the organisation with a strong emphasis on sustainable sourcing, upcycling, recycling and the circular economy. With these and other measures, Paris is on track"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <img id=\"7-quote-1\" class=\"halfScale\" style=\"top:621px;left:43px\" src=\"/122/static/_content/7-quote-1.png\"/>\n        <div id=\"7-sig\" class=\"abs noOverflow\" style=\"top: 781px; left: 474px;    height: 43px; width: 142px;background:white\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax()\n          pg7Anim\n            .fromTo(idOf(\"7-quote-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.2)\n            .fromTo(idOf(\"7-sig\"), 0.6, {width:146,x:0}, {width: 0,x:146, ease: Power2.easeOut, onComplete: addContentLinks}, 1.4)\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop()\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Review  7  Issue 122  'Full gender parity will be achieved on the ﬁeld of play because the IOC allocated 50 per cent of places to women and 50 per cent to men'  to achieve this ambitious goal already six years ahead of the global 2030 target set by the Paris Agreement on Climate Change. At the same time, ensuring a long-term legacy has also been a key part of the Games' organisation. From the outset, the organisers have sought to ensure a  strong social legacy not just in Paris, but throughout France. Social projects aimed at reinvigorating the Seine-Saint-Denis region of France are already bearing fruit, while the '30 minutes d'activité physique quotidiennes' programme in primary schools is reaching 4.2 million children. In the following pages, you will be able to read all about these and other initiatives as Paris and France prepare to welcome the world. This Olympic Review also explores the French landmarks that will serve as competition venues and what athletes and spectators alike can expect at the Games. Finally, the Olympic Review pays homage to the visionary founder of the  IOC, Pierre de Coubertin, who reinstated the Olympic Games 130 years ago. As the Olympic Games return to his birthplace of Paris for the ﬁrst time in 100 years, his vision to bring the world together in a display of peace and unity endures to this day. As we look to the Olympic Games Paris 2024, all the signs are that this event will live up to this vision. ■  Thomas Bach, IOC President"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n\n        <!-- ANIMATION -->\n        <img class=\"halfScale 8-title-1\" style=\"top:35px; left:36px;\" src=\"/122/static/_content/8-title-1.png\" />\n        <img class=\"halfScale 8-title-2\" style=\"top:35px; left:122px;\" src=\"/122/static/_content/8-title-2.png\" />\n        <img class=\"halfScale 8-sub-1\" style=\"top:664px; left:35px;\" src=\"/122/static/_content/8-sub-1.png\" />\n\n\n        <!--LINKY-->\n        <div class=\"addContentLinkThree\" style=\"top:729px; left:35px; width:99px; height:15px;\">\n          <a href=\"https://olympics.com/ioc/news/less-better-and-for-longer-five-ways-paris-2024-is-delivering-more-sustainable-games\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLinkThree\" style=\"top:747px; left:34px; width:141px; height:15px;\">\n          <a href=\"https://olympics.com/ioc/news/less-better-and-for-longer-five-ways-paris-2024-is-delivering-more-sustainable-games\" target=\"_blank\"></a>\n        </div>\n\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim\n            .fromTo(cOf(\"8-title-1\"), 0.8, {opacity:0, y:40}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"8-title-2\"), 0.8, {opacity:0, y:40}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"8-sub-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1);\n\n\n\n          \n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n          removeContentLinks();\n\n        }\n      ",
    "searchText": "A VIRTUOUS CIRCLE SOCIAL BUSINESSES AND CIRCULAR ECONOMY PRINCIPLES ARE KEY TO THE SUSTAINABILITY LEGACY OF PARIS 2024. BUT CAN THE GAMES ACCELERATE TO A NEW WAY OF DOING THINGS? BY MATTHEW CAMPELLI AND GEORGE TIMMS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "The Paris 2024 sailing competition will take place at Marseille Marina."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "10  Feature: Sustainability legacy  1  A  1 The new Aquatics Centre aligns with the Games' environmental objectives. 2 A newly built bridge will transform the Saint-Denis area for locals.  bridge is such a wonderful visual metaphor for moving towards a brighter future and creating connecting blocks between the current status quo to something better. As humans, we have built bridges for centuries to explore unfamiliar places and seek out lands more promising than the ones we left behind. Bridges create opportunities for people to experience new things and expand their worlds beyond their homes and immediate surroundings. It is hoped that the bridge that has been constructed alongside the recently built Aquatics Centre ahead of Paris 2024 will add texture to the lives of many people - particularly those living in its Saint-Denis region. With trees, bushes and benches, the bridge will give people living in the area access to close-by green spaces, which are so rare in many big cities globally. Only about 11 per cent of Paris is covered by green space, while its 20 per cent of tree cover is lower than the European capital cities' average of 29 per cent. Urban areas with low socioeconomic status like Saint-Denis have, in general, disproportionately fewer green spaces available than affluent areas of cities, so amenities on the bridge will bring some much-needed respite for local people, particularly when contending with the surging temperatures during the summer. Constructed across one of the city's busiest motorways, the bridge connects three Paris metro stations, the Stade de France and the Aquatics Centre, which will host diving, artistic swimming and water polo qualiﬁcation at Paris 2024 before becoming a community facility in the aftermath of the Games. Both the bridge and the Aquatics Centre will be starting points for a new sustainability- and wellbeing-focused neighbourhood, which is being developed for the Saint-Denis area. Laure Mériaud, president and associate architect for Ateliers 2/3/4, says the facilities and the Games represent the 'beginning of a new adventure'"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATIONS -->\n        <img class=\"halfScale 11-sub-1\" style=\"top:607px; left:527px;\" src=\"/122/static/_content/11-sub-1.png\" />\n        <img class=\"halfScale 11-sub-2\" style=\"top:700px; left:527px;\" src=\"/122/static/_content/11-sub-2.png\" />\n        <img class=\"halfScale 11-sub-3\" style=\"top:793px; left:527px;\" src=\"/122/static/_content/11-sub-3.png\" />\n\n        <!-- PERCENT/LINE ANIMS -->\n        <img class=\"halfScale 11-percent-1\" style=\"top:578px; left:559px;\" src=\"/122/static/_content/11-percent-1.png\" />\n        <img class=\"halfScale 11-percent-2\" style=\"top:672px; left:565px;\" src=\"/122/static/_content/11-percent-1.png\" />\n        <img class=\"halfScale 11-percent-3\" style=\"top:765px; left:558px;\" src=\"/122/static/_content/11-percent-1.png\" />\n\n        <img class=\"halfScale 11-line-1\" style=\"top:569px; left:526px;\" src=\"/122/static/_content/11-line-1.png\" />\n        <img class=\"halfScale 11-line-2\" style=\"top:663px; left:526px;\" src=\"/122/static/_content/11-line-1.png\" />\n        <img class=\"halfScale 11-line-3\" style=\"top:755px; left:526px;\" src=\"/122/static/_content/11-line-1.png\" />\n\n        <!-- NUMBERS -->\n        <h1 class=\"abs paris2024B 11-no\" style=\"top: 572px; left: 526px; font-size: 1.9em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\" data-number='{\"to\": 95}' ></h1>\n        <h1 class=\"abs paris2024B 11-no\" style=\"top: 665px; left: 526px; font-size: 1.9em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\" data-number='{\"to\": 50}' ></h1>\n        <h1 class=\"abs paris2024B 11-no\" style=\"top: 758px; left: 526px; font-size: 1.9em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\" data-number='{\"to\": 25}' ></h1>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax();\n          pg11Anim.fromTo(cOf(\"11-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no\")[0]);}}, 1.10);\n          pg11Anim.fromTo(cOf(\"11-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no\")[1]);}}, 1.35);\n          pg11Anim.fromTo(cOf(\"11-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no\")[2]);}}, 1.60);\n\n          pg11Anim\n            .fromTo(cOf(\"11-line-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.0)\n            .fromTo(cOf(\"11-line-2\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.25)\n            .fromTo(cOf(\"11-line-3\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.5)\n            .fromTo(cOf(\"11-sub-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.05)\n            .fromTo(cOf(\"11-sub-2\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.30)\n            .fromTo(cOf(\"11-sub-3\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.55)\n            .fromTo(cOf(\"11-percent-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.10)\n            .fromTo(cOf(\"11-percent-2\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.35)\n            .fromTo(cOf(\"11-percent-3\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.60);\n\n\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop();\n          resetNumbers(\"11-no\");\n\n        }\n      ",
    "searchText": "Olympic Review  11  Issue 122  2  for an area of Paris that not only requires signiﬁcant investment, but that also has one of the youngest populations in the whole of France. At the heart of Paris 2024's sustainability strategy, and its ambition to generate only half of the carbon emissions of previous Games in London and Rio, was the pledge to use a portfolio of sporting facilities of which 95 per cent were temporary or had already been built. However, the Aquatics Centre, one piece of permanent sporting infrastructure that did have to be developed from scratch, is perhaps one of the symbols that best represents the scale of the Organising Committee's vision to redeﬁne sustainability standards for multi-sport events. According to Mériaud and Cécilia Gross, partner at VenhoevenCS, which collaborated with Ateliers 2/3/4 in a consortium to develop the venue, every aspect of traditional aquatics  centre design and construction was thoroughly reconsidered to align with the Games' environmental objectives. The shape of the roof - an eye-catching curve made from 55-centimetre-thick timber - will help slash the energy use in the facility by 50 per cent by reducing the need for air stability and heating. The shape of the pools will differ from previous editions of the Games, saving water by 25 per cent. And solar panels have covered the roof, providing a signiﬁcant amount of energy for the centre. 'We want to do better with less,' says Gross, who will run in the Olympic Torch Relay alongside Mériaud ahead of the Games. 'We had to rethink everything - the materials we used, the right measures to take. We had to make the right choice for the venue to remain relevant.' To ensure the project venue aligned with the Games' sensibilities and the needs  95%  of Paris 2024 venues are existing or temporary facilities  50%  reduction in Aquatics Centre energy use from the shape of the roof  25%  saving in use of water in Aquatics Centre swimming pools"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATIONS -->\n        <img class=\"halfScale 12-quote-1\" style=\"top:705px; left:476px;\" src=\"/122/static/_content/12-quote-1.png\" />\n\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.fromTo(cOf(\"12-quote-1\"), 0.8, {opacity:0, y:40}, {opacity:1, y:0, ease: Power2.easeOut}, 1);\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n        }\n      ",
    "searchText": "12  Feature: Sustainability legacy  of the city, the Métropole du Grand Paris (the city's local authority) tendered the project out as a 'DBFMO' (Design, Build, Finance, Maintain and Operate), so that professionals and organisations with expertise in these ﬁelds could combine their points of perspective and end up with a ﬁnished product that encapsulated environmental, human and economic sustainability. Paris 2024's sustainability strategy aligns with the Métropole's own Climate, Air and Energy Plan, which has a number of objectives around increasing the city's climate resilience, air quality and energy efficiency, as well as a 13-priority Biodiversity Plan. It was crucial that any new facility worked towards these wider environmental goals. As well as taking cues from the local authority, the consortium interviewed local people in Saint-Denis about what they wanted from the facility in terms of sport, and what they needed from it in their everyday lives. During the Games and other major events, like the European Aquatics Championships, which Paris will host in 2026, the Aquatics Centre will be populated with 6,000 seats. This will be reduced to 3,000 seats for normal periods, with the additional 3,000 giving way to padel courts and other sporting facilities. Le Pavé, an industrial start-up that only incorporated as a business in 2018, was handed the opportunity to produce those  1 The Aquatics Centre will become a community facility after the Games. 2 Le Pavé was commissioned to support the Paris 2024 circularity vision.  2  1  ' We had to rethink everything - the materials we used, the right measures to take. We had to make the right choice for the venue to remain relevant' Cécilia Gross, VenhoevenCS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n\n        <!-- Animation -->\n        <img class=\"halfScale 14-quote-1\" style=\"top:107px; left:476px;\" src=\"/122/static/_content/14-quote-1.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.fromTo(cOf(\"14-quote-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n        }\n      ",
    "searchText": "14  Feature: Sustainability legacy  seats - as well as a further 8,000 for the Porte de La Chapelle Arena - because of its ability to manufacture them from 100 per cent plastic waste that was collected in the Paris region. Lucas Philipponneau, Le Pavé's chief of staff, tells the story of a young ambitious company, started by university friends with the desire to 'rethink the value chain', that had to transform overnight after being commissioned to support the circularity vision of Paris 2024. 'The company existed for a year when we received this challenge,' he says. 'We went from being very small to having a dedicated team of engineers and the need to build factories in France to scale. 'The Olympics are an occasion to show what's possible and to build things another way. We can create big projects with circular economy and social economic principles. The Games have made it possible to attempt a new level and stimulate innovation.' Indeed, embedding a circular economy approach is one of the ﬁve strategic pillars of Paris 2024's procurement strategy, which comprises ﬁve steps: rethinking ways to do things; reducing the use of resources; reusing equipment; recycling products; and reassembling the Games ecosystem. While Le Pavé's use of single-use plastics (HDPE plastic, which comes from products like shampoo bottles, and PS plastic, often located inside household items like fridges) falls squarely into the 'recycle' category of that hierarchy, 'rethinking' and 'reducing' are the ﬁrst priority. Paris 2024 has worked with Worldwide Olympic Partner Coca-Cola on reducing its packaging. Coca-Cola will install 700 beverage fountains across all Paris 2024 sites, and the organisers will install free drinking water points. Spectators will be allowed to enter all venues with their own reusable bottles, a notable exception to existing French regulations. Around half of the 4.8 million tonnes of plastic used and disposed of in France annually is packaging. Of that, only 23 per cent is recycled - lower than the EU average of 38 per cent. This falls even further to 14 per cent in Paris. Around 37 per cent of waste produced in the city comes from packaging, and the Organising Committee has tried to address this further by requiring logistics partners  ' We can create big projects with circular economy and social economic principles. The Games have made it possible to attempt a new level' Lucas Philipponneau, Le Pavé  1  to reduce their packaging and use of plastic, as well as by establishing a deposit system for pallets. Paris 2024 extends its resource-saving ethos to the interior design of its 40 venues, meticulously assessing and consolidating needs, resulting in a reduction of furniture items from 800,000 to 600,000. Furthermore, organisers have prioritised hiring over purchasing, with three-quarters of sports equipment and 75 per cent of electronic devices sourced through rental agreements. Strategic partnerships ensure that all stands, tents and bungalows for the Games have been hired, not bought, minimising the event's environmental impact. All of the furniture and 90 per cent of signage used for the Games will be given a second life, reused, redeployed or recycled, and 100 per cent of the materials used for temporary infrastructure will also be given a second life, with 50 per cent remaining in France. Vincent Brenot, an environmental lawyer based in Paris, believes that France's 'advanced regulatory landscape' for circular economy and waste management means the  1 Water fountains will reduce the number of single-use plastic bottles in circulation. 2 The seats of the Porte de La Chapelle Arena and the Aquatics Centre (pictured) are made from plastic waste.  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  15  Issue 122  Games have a signiﬁcant opportunity to promote a more responsible model of production and consumption throughout the nation and beyond. According to EU law, large companies are obligated to partner with smaller, innovative companies to give them 'access to public purchase'. The high-proﬁle nature of the Games means they can be an 'instrument of promotion' of the 'real-life implementation of these principles'.  Ultimately, the Games present an opportunity for sport - and major sports events speciﬁcally - to rip up the rulebook and do things differently. Like the bridge outside the Aquatics Centre connecting the Saint-Denis suburb to a more sustainable and equitable future, Paris 2024 can act as a bridge to a new way of organising big events, where environmental and social responsibility are paramount.  Part of this is using its high proﬁle to stimulate innovation and establish fertile ground for social and environmental entrepreneurship. While small, nimble start-ups like Le Pavé have been nurtured to support the circular economy goals of the Games, they also represent a wider vision for Paris 2024 to facilitate and supercharge the social and environmental entrepreneurship landscape. To establish new precedents for major sports events, the Organising Committee created 'ESS 2024' to forge a link to the teeming world of social entrepreneurship in the city and beyond. ESS 2024 has made it possible to inform, mobilise and support social businesses"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n\n        <!-- Animation -->\n        <img class=\"halfScale 16-quote-1\" style=\"top:514px; left:44px;\" src=\"/122/static/_content/16-quote-1.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.fromTo(cOf(\"16-quote-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n        }\n      ",
    "searchText": "16  Feature: Sustainability legacy  1  'The Olympics are a big sports event but also an economic event that can promote social business' Elisa Yavchitz, Les Canaux  2  1 Small businesses like Street Food en Mouvement will be involved in the Games. 2 Paris 2024 has pioneered new ways to host a major event since being awarded the Games in 2017.  and entrepreneurs, positioning them at the heart of organising the Games. Joining forces with Paris 2024 and the Olympic Works Delivery Company (SOLIDEO), one of the main bodies supporting ESS 2024 is Les Canaux, that manages the House of Social and Solidarity Economies. Founded seven years ago, Les Canaux is a predominantly state-funded organisation that supports the development of an engaged economy (solidarity, circular and local) by training and raising awareness among citizens, businesses and communities about social and environmental innovation. 'The Olympics are a big sports event but also an economic event that can promote social business,' says Elisa Yavchitz, director general of Les Canaux. After being moved by a speech delivered by 2006 Nobel Peace Prize winner Professor Muhammad Yunus when Paris was awarded the Games in 2017, Yavchitz had a 'lightbulb moment', realising the contribution Les Canaux could have through the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top: 829px;left: 437px;width: 158px;height: 22px;\">\n          <a href=\"http://www.panasonic.com/eu/team\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "Hannah Mills Sailor | GBR  Sustainability is a team effort. Vahiné Fierro Surfer | FRA  TOGETHER. ACTI N. PROGRESS. Hannah Cockroft Wheelchair Racer | GBR"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "18  Feature: Sustainability legacy  The Yunus Centre, a global hub for social business created by Yunus, joined forces with Les Canaux to co-design the programme. Established in 2019 to 'create a world of zero poverty, zero unemployment, and zero net carbon emissions', the Yunus Centre positions 'social businesses' as the remedy to help solve these three macro issues. A social business, as deﬁned by the Centre, has a primary aim to address a social problem, is ﬁnancially self-sufficient and does not pay dividends to its owners. It is also well positioned to integrate and fast-track disabled people and long-term unemployed people into the workforce, says Yavchitz. Connecting the signiﬁcant economic opportunities of Paris 2024, she adds, is a huge part of the Games' overall legacy as, often, small- and medium-sized social businesses have a solution, or partial solution, to big societal problems, but are held back by a lack of reputation or capital to really scale their work. Yoan Noguier, a co-founder and the managing director of the Yunus Sports Hub (part of the Yunus Centre), hopes that the connection with the Games will deliver legitimacy to the social business model in the eyes of government and investors,  1  1 The Yunus Centre has helped promote the involvement of social businesses at Paris 2024. 2 Cycle Terre made mud bricks for the Porte de La Chapelle Arena.  2  and untangle its link with the charitable and philanthropic sector. Around 460 social businesses have been given the opportunity to provide services for the Games, in the ﬁelds of construction, catering, furniture provision and laundry services, with nine of those businesses winning EUR 1.6 million worth of work. 'If we can use one per cent of the airtime of the Olympic Games to showcase these social businesses, that will really  level the playing ﬁeld, give social businesses a 'halo effect' and demonstrate that social businesses can win tenders and compete in the same ﬁeld as big organisations,' Noguier says. Through his experience as procurement manager for the Olympic Games Rio 2016, Noguier helped Yavchitz and Les Canaux understand what 2 the Games would need, how to gain commitments of local authorities and share networks of social businesses around Paris. The result was ESS 2024, which helped to deﬁne tenders that were accessible to small- and medium-sized social businesses, as well as signposting opportunities for social businesses to partner up with larger ﬁrms, or to create their own consortium. Like Le Pavé, Cycle Terre is a small social enterprise beneﬁtting from the ESS 2024 programme. Born from a European experimentation project, Cycle Terre explores the use of raw earth materials to create construction items. Using rubble from construction sites (which represents about 90 per cent of urban waste), Cycle Terre produced mud bricks used to build the Porte de La Chapelle Arena, which will host badminton and rhythmic gymnastics, and the Olympic Village. From 1 July, and throughout Paris 2024, Les Canaux will host a festival at the Maison des Canaux to promote companies like Le Pavé and Cycle Terre and celebrate their contribution to the Games. A photo exhibition curated by Yann Arthus-Bertrand will showcase the social businesses, and learning expeditions will introduce interested parties"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        \n        <!-- Group -->\n        <div class=\"abs\" style=\"top:-460px; left:-483px;\">\n          <!-- ANIMATIONS -->\n          <img class=\"halfScale 20-sub-1\" style=\"top:607px; left:527px;\" src=\"/122/static/_content/20-sub-1.png\" />\n          <img class=\"halfScale 20-sub-2\" style=\"top:700px; left:527px;\" src=\"/122/static/_content/20-sub-2.png\" />\n          <img class=\"halfScale 20-sub-3\" style=\"top:793px; left:527px;\" src=\"/122/static/_content/20-sub-3.png\" />\n\n          <!-- PERCENT/LINE ANIMS -->\n          <img class=\"halfScale 20-percent-1\" style=\"top:578px; left:581px;\" src=\"/122/static/_content/20-percent-1.png\" />\n          <img class=\"halfScale 20-percent-3\" style=\"top:765px; left:556px;\" src=\"/122/static/_content/20-percent-1.png\" />\n\n          <img class=\"halfScale 20-line-1\" style=\"top:569px; left:526px;\" src=\"/122/static/_content/20-line-1.png\" />\n          <img class=\"halfScale 20-line-2\" style=\"top:663px; left:526px;\" src=\"/122/static/_content/20-line-2.png\" />\n          <img class=\"halfScale 20-line-3\" style=\"top:755px; left:526px;\" src=\"/122/static/_content/20-line-3.png\" />\n\n          <!-- NUMBERS -->\n          <h1 class=\"abs paris2024B 20-no\" style=\"top: 572px; left: 526px; font-size: 1.9em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\" data-number='{\"to\": 100}' ></h1>\n          <h1 class=\"abs paris2024B 20-no\" style=\"top: 665px; left: 526px; font-size: 1.9em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\" data-number='{\"to\": 460}' ></h1>\n          <h1 class=\"abs paris2024B 20-no\" style=\"top: 758px; left: 526px; font-size: 1.9em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\" data-number='{\"to\": 75}' ></h1>\n        </div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.fromTo(cOf(\"20-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[0]);}}, 1.10);\n          pg20Anim.fromTo(cOf(\"20-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[1]);}}, 1.35);\n          pg20Anim.fromTo(cOf(\"20-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[2]);}}, 1.60);\n\n          pg20Anim\n            .fromTo(cOf(\"20-line-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.0)\n            .fromTo(cOf(\"20-line-2\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.25)\n            .fromTo(cOf(\"20-line-3\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.5)\n            .fromTo(cOf(\"20-sub-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.05)\n            .fromTo(cOf(\"20-sub-2\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.30)\n            .fromTo(cOf(\"20-sub-3\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.55)\n            .fromTo(cOf(\"20-percent-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.10)\n            .fromTo(cOf(\"20-percent-2\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.35)\n            .fromTo(cOf(\"20-percent-3\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.60);\n\n\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop();\n          resetNumbers(\"20-no\");\n\n\n        }\n      ",
    "searchText": "20  Feature: Sustainability legacy  100  %  of furniture used at Paris 2024 will be reused or recylced  460  social businesses invited to provide services for the Games  75%  of electronic devices sourced through rental agreements  1  to the individuals behind the organisations and their innovations. Beyond Paris 2024, Yavchitz believes that any big public project needs an intermediate programme like ESS 2024 to coordinate between organisers, public stakeholders and small social and medium enterprises. 'The cost of the programme is nothing compared to the beneﬁt,' she states. Yavchitz and Noguier are not the only ones who feel this way. As part of its international promotion effort of ESS 2024, the Yunus Centre organises the Global Business Summit. At the 2022 edition in Turin, they approached organisers of the Olympic Winter Games Milano Cortina 2026 and, as Noguier describes, 'engaged them in ESS 2024 and the idea of social procurement'. One step quickly followed another when, at the beginning of 2024, a direct replication of ESS called Impact 2026 was launched, where the Yunus Centre will work with  Italian organisation Fondazione Giacomo Brodolini in a similar vein to Les Canaux. 'Once is luck, twice is the norm,' remarks Noguier. 'Hopefully another organisation will be established in Los Angeles if we manage to replicate it there.' Paris 2024 may serve as the foundation for a new social and circular business model. Its true legacy will be seen if future hosts and major sporting events continue to strengthen and expand this bridge, establishing this method as the standard practice. ■  1 Organisers hope Paris 2024 will provide a new business model for future events. 2 A cleaning operation for the River Seine was launched thanks to the Olympic Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  21  Issue 122  2  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- Animation -->\n        <img class=\"halfScale 22-title-1\" style=\"top:141px; left:43px;\" src=\"/122/static/_content/22-title-1.png\" />\n        <img class=\"halfScale 22-title-2\" style=\"top:254px; left:62px;\" src=\"/122/static/_content/22-title-2.png\" />\n        <img class=\"halfScale 22-title-3\" style=\"top:368px; left:59px;\" src=\"/122/static/_content/22-title-3.png\" />\n        <img class=\"halfScale 22-sub-1\" style=\"top:506px; left:215px;\" src=\"/122/static/_content/22-sub-1.png\" />\n      \n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim\n            .fromTo(cOf(\"22-title-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.0)\n            .fromTo(cOf(\"22-title-2\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.1)\n            .fromTo(cOf(\"22-title-3\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.2)\n            .fromTo(cOf(\"22-sub-1\"), 0.8, {opacity:0, y:40}, {opacity:1, y:0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n        }\n      ",
    "searchText": "THE SPORTING LEGACY  A CENTURY ON FROM WHEN THE CITY LAST HOSTED THE OLYMPIC GAMES, PARIS 2024 AIMS TO LEAVE A POSITIVE SOCIAL LEGACY ACROSS FRANCE FOR YEARS TO COME AND TO SET A NEW BLUEPRINT FOR MAJOR SPORTS EVENTS. BY NICOLAS PECHEROT  '1,2,3 Swim!' is one of many ways that Paris 2024 is helping children to get active."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"addContentLinkThree\" style=\"top:780px; left:473px; width:184px; height:15px;\">\n        <a href=\"https://olympics.com/en/paris-2024/our-commitments/promoting-the-role-of-sports/30-minutes-every-day\" target=\"_blank\"></a>\n      </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){addContentLinks();}, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "24  Feature: Paris 2024 vision  P  aris is a celebration, in 2024 more than ever. But by hosting the Olympic and Paralympic Games, Paris is also a fantastic opportunity for France: to give sport a more central place and use its positive social impact in everyone's daily lives for the future. 'We chose to organise the Games because we believe that sport has the power to change everything', as Tony Estanguet, President of the Paris 2024 Organising Committee, has insisted ever since the French capital was picked to host the Games of the XXXIII Olympiad. One hundred years after it last hosted the Games, Paris is at a turning point in Olympic history, we know that. Not least because these will be the ﬁrst-ever gender-balanced Olympic Games, with as many female as male athletes centre stage. And also because the 'City of Light' will be hosting the ﬁrst Games to fully incorporate the objectives of Olympic Agenda 2020, the strategic roadmap for the IOC and the Olympic Movement. Games that are more responsible, more sustainable - with half the carbon footprint of previous editions - and more inclusive and open in terms of economic opportunities. With this new model, Paris 2024 intends to inspire the organisers of subsequent editions and, more broadly, leave a legacy of methods and tools that will beneﬁt all major events.  Sport and the Games: fantastic drivers of change The Paris 2024 ambition is (even) greater. It is summed up by the 'Games wide open' slogan created by the Organising Committee to cover all aspects. Opening the Games to the challenges facing society means using sport as a driver of change, making its positive social impact a means to combat issues such as physical inactivity, discrimination and gender inequality. How? By exploiting the acceleration effect of the Games to give sport a more central place - 'the place it deserves', as Paris 2024 likes to say - in a country where it has never been a priority. Something that the Minister for Sport and the Olympic and Paralympic Games, Amélie Oudéa-Castéra, summarises elegantly when she calls for France to move from being 'a nation of great athletes to a great sporting nation'.  1  But the reality is very clear: 'France is a sedentary and inactive country' according to Michel Cymès, a doctor and Paris 2024 Health Ambassador. A World Health Organization (WHO) study on the level of physical activity and sport among teenagers in 146 countries puts France in 119th place.  1 Encouraging children to take part in sport and daily activity has been a key goal for Paris 2024. 2 A 30-minute daily physical activity programme was launched in schools in 2020.  'The health effects are catastrophic, and physical inactivity is the third biggest cause of preventable death. In short, more and more children are suffering from illnesses normally seen among old people,' Cymès says.  Physical activity: 30 minutes a day for everyone Ever since the candidature phase, Paris 2024 has made developing the practice of sport and physical activity the cornerstone of its legacy strategy, with the desire to impact"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        \n        <!-- ANIMATIONS -->\n        <img class=\"halfScale 25-sub-1\" style=\"top:774px; left:89px;\" src=\"/122/static/_content/25-sub-1.png\" />\n        <img class=\"halfScale 25-sub-2\" style=\"top:774px; left:247px;\" src=\"/122/static/_content/25-sub-2.png\" />\n        <img class=\"halfScale 25-sub-3\" style=\"top:774px; left:392px;\" src=\"/122/static/_content/25-sub-3.png\" />\n        <img class=\"halfScale 25-sub-4\" style=\"top:774px; left:521px;\" src=\"/122/static/_content/25-sub-4.png\" />\n\n        <!-- LINE ANIMS -->\n        <img class=\"halfScale 25-line-1\" style=\"top:735px; left:89px;\" src=\"/122/static/_content/25-line-1.png\" />\n        <img class=\"halfScale 25-line-2\" style=\"top:735px; left:247px;\" src=\"/122/static/_content/25-line-2.png\" />\n        <img class=\"halfScale 25-line-3\" style=\"top:735px; left:392px;\" src=\"/122/static/_content/25-line-3.png\" />\n        <img class=\"halfScale 25-line-4\" style=\"top:735px; left:521px;\" src=\"/122/static/_content/25-line-4.png\" />\n\n        <!-- Misc -->\n        <img class=\"halfScale 25-million-1\" style=\"top:752px; left:264px;\" src=\"/122/static/_content/25-million-1.png\" />\n\n\n        <!-- NUMBERS -->\n        <h1 class=\"abs paris2024B 25-no\" style=\"top: 735px; left: 88px; font-size: 1.9em; font-weight:300; margin:0; color:#101747; padding:0; margin:0;\" data-number='{\"to\": 36250, \"comma\":true}' ></h1>\n        <h1 class=\"abs paris2024B 25-no\" style=\"top: 735px; left: 246px; font-size: 1.9em; font-weight:300; margin:0; color:#101747; padding:0; margin:0;\" data-number='{\"to\": 5}' ></h1>\n        <h1 class=\"abs paris2024B 25-no\" style=\"top: 735px; left: 392px; font-size: 1.9em; font-weight:300; margin:0; color:#101747; padding:0; margin:0;\" data-number='{\"to\": 1500, \"comma\":true}' ></h1>\n        <h1 class=\"abs paris2024B 25-no\" style=\"top: 735px; left: 521px; font-size: 1.9em; font-weight:300; margin:0; color:#101747; padding:0; margin:0;\" data-number='{\"to\": 10278, \"comma\":true}' ></h1>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          resetNumbers(\"25-no\");\n          pg25Anim = new TimelineMax();\n          pg25Anim.fromTo(cOf(\"25-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[0]);}}, 1.00);\n          pg25Anim.fromTo(cOf(\"25-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[1]);}}, 1.25);\n          pg25Anim.fromTo(cOf(\"25-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[2]);}}, 1.50);\n          pg25Anim.fromTo(cOf(\"25-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[3]);}}, 1.75);\n\n          pg25Anim\n            .fromTo(cOf(\"25-line-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.0)\n            .fromTo(cOf(\"25-line-2\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.25)\n            .fromTo(cOf(\"25-line-3\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.5)\n            .fromTo(cOf(\"25-line-4\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.75)\n            .fromTo(cOf(\"25-million-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.25)\n            .fromTo(cOf(\"25-sub-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.05)\n            .fromTo(cOf(\"25-sub-2\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.30)\n            .fromTo(cOf(\"25-sub-3\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.55)\n            .fromTo(cOf(\"25-sub-4\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.80)\n            .fromTo(cOf(\"25-percent-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.10)\n            .fromTo(cOf(\"25-percent-2\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.35)\n            .fromTo(cOf(\"25-percent-3\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.60)\n            .fromTo(cOf(\"25-percent-4\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.85);\n\n\n\n\n        }\n\n        function onPageLeave() {\n          pg25Anim.stop();\n          resetNumbers(\"25-no\");\n        }\n      ",
    "searchText": "2  2  Education at a glance  36,250  5MILLION+  1,500  10,278  sports equipment kits distributed, with 100 per cent of primary schools covered by the end of June 2024  students reached through Olympic and Paralympic Week (SOP) since 2017  active and sporting school playgrounds by 2026  schools with the 'Génération 2024' label, of which more than 460 are in Seine-Saint-Denis"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n\n      <!--ANIMATIONS-->\n      <div class=\"addContentLinkThree\" style=\"top:741px; left:43px; width:84px; height:15px;\">\n        <a href=\"https://olympics.com/en/paris-2024/our-commitments/promoting-the-role-of-sports/generation-2024\" target=\"_blank\"></a>\n      </div>\n\n      <!--ANIMATION-->\n      <img class=\"halfScale 26-quote-1\" style=\"top:528px; left:260px;\" src=\"/122/static/_content/26-quote-1.png\" />\n\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg26Anim = new TimelineMax({onComplete: addContentLinks});\n        pg26Anim.fromTo(cOf(\"26-quote-1\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 1.0);\n\n      }\n\n      function onPageLeave() {\n        removeContentLinks();\n        pg26Anim.stop();\n      }\n      ",
    "searchText": "26  Feature: Paris 2024 vision  1  French people's daily lives and focus particularly on those furthest away from sport. In 2018, the Organising Committee teamed up with the 'Pour une France en forme' (For a ﬁt France) group of independent experts, of which Cymès is a member, to take advantage of the Games to boost sport for health. The 30 minutes of daily physical activity programme then became part of these basic ambitions. It was ﬁrst rolled out in schools, to instil healthy lifestyle habits at an early age and reach all children, whatever their social background. It was then extended to towns and workplaces, in short to everyone's daily lives. 'When I started in 2018, my role was to create the Paris 2024 education programme ('Génération 2024'), to bring together the various sport and education stakeholders in France to build a project that everyone could be a part of,' recalls Emmeline Ndongue, a former French national team basketball player, who was previously Paris 2024 Education Project Manager and has now joined the team organising the mass participation events.  'The reports by WHO and then the ONAPS quickly led us to set a main priority: combating physical inactivity' Emmeline Ndongue, Former Education Project Manager for Paris 2024  'The reports by the WHO and then the ONAPS (the National Observatory for Physical Activity and Sedentary Behaviours) quickly led us to set a main priority: combating physical inactivity. How do you pick up good habits when you're young? And because these good habits are acquired in and around schools, how do we support them in terms of education on the ground and in classrooms?' Based on the success of similar programmes  abroad, in particular 'Schools on the Move' in Finland, in 2020 Paris 2024 started encouraging the adoption of 30 minutes of daily physical activity in primary schools, on top of physical education and sports lessons. In cooperation with the French Ministry of Education and Youth, the initiative was successfully trialled and then spread to all primary schools across the country. By the start of the new school year in 2022, 10,000 schools had applied, with 11,000 in 2023. The roll-out is continuing, and to support it, Paris 2024 and the National Sports Agency (ANS) are co-ﬁnancing a sports equipment kit which is sent to participating schools. French President Emmanuel Macron has said he wants to expand this further, taking the programme to every school (it is currently being trialled in 700 secondary schools) and increasing it to an hour of physical activity every day by 2026. 1 'Génération 2024' promotes using sports for educational purposes."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n\n        <!--Linky-->\n        <div class=\"addContentLinkThree\" style=\"top:767px; left:102px; width:58px; height:15px;\">\n          <a href=\"https://olympics.com/en/paris-2024/our-commitments/promoting-the-role-of-sports/1-2-3-swim\" target=\"_blank\"></a>\n        </div>\n\n        <!-- Div -->\n        <div class=\"abs\" style=\"top:108px; left:287px;\">\n          \n          <img class=\"halfScale 27-title-1\" style=\"top:27px; left:28px;\" src=\"/122/static/_content/27-title-1.png\" />\n          \n          <!-- Info1 -->\n          <div class=\"abs\" style=\"top:102px; left:26px;\">\n            \n            <img class=\"halfScale 27-line-1\" style=\"top:0px; left:0px;\" src=\"/122/static/_content/27-line-1.png\" />\n            <img class=\"halfScaleC 27-icon-1\" style=\"top:-9px; left:26px;\" src=\"/122/static/_content/27-icon-1.png\" />\n            <img class=\"halfScaleC 27-sub-1\" style=\"top:27px; left:-18px;\" src=\"/122/static/_content/27-sub-1.png\" />\n\n            <h1 class=\"abs paris2024B 27-no\" style=\"top: 3px; left: 2px; font-size: 2.0em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\"data-number='{\"to\": 5}' ></h1>\n\n          </div>\n\n          <!-- Info2 -->\n          <div class=\"abs\" style=\"top:102px; left:163px;\">\n\n            <img class=\"halfScale 27-line-2\" style=\"top:0px; left:0px;\" src=\"/122/static/_content/27-line-2.png\" />\n            <img class=\"halfScaleC 27-icon-2\" style=\"top:22px; left:-19px;\" src=\"/122/static/_content/27-icon-2.png\" />\n            <img class=\"halfScaleC 27-sub-2\" style=\"top:21px; left:2px;\" src=\"/122/static/_content/27-sub-2.png\" />\n\n            <h1 class=\"abs paris2024B 27-no\" style=\"top: 0px; left: 3px; font-size: 2.0em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\"data-number='{\"to\": 4000, \"append\":\"+\"}' ></h1>\n          \n          </div>\n\n          <!-- Info3 -->\n          \n            <div class=\"abs\" style=\"top:187px; left:26px;\">\n\n              <img class=\"halfScale 27-line-3\" style=\"top:2px; left:3px;\" src=\"/122/static/_content/27-line-3.png\" />\n              <img class=\"halfScaleC 27-sub-3\" style=\"top:30px; left:-34px;\" src=\"/122/static/_content/27-sub-3.png\" />\n              <div class=\"abs\" style=\"top:-9px; left:-10px;\"> \n\n\n              <h1 class=\"abs paris2024B 27-no\" style=\"top: 12px; left: 11px; font-size: 2.0em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\"data-number='{\"to\": 20}' ></h1>\n\n                <!-- Wrench Anim -->\n                <div class=\"abs\" style=\"top:65px; left:3px;\">\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:0px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:21px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:42px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:63px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:84px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                </div>\n\n                <div class=\"abs\" style=\"top:86px; left:3px;\">\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:0px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:21px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:42px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:63px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:84px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                </div>\n\n                <div class=\"abs\" style=\"top:107px; left:3px;\">\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:0px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:21px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:42px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:63px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:84px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                </div>\n\n                <div class=\"abs\" style=\"top:129px; left:3px;\">\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:0px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:21px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:42px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:63px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                  <img class=\"halfScaleC 27-icon-3\" style=\"top:0px; left:84px;\" src=\"/122/static/_content/27-icon-3.png\" />\n                </div>\n            \n              </div>\n            </div>\n\n          <!-- Info4 -->\n          <div class=\"abs\" style=\"top:206px; left:163px;\">\n\n            <img class=\"halfScale 27-line-4\" style=\"top:1px; left:0px;\" src=\"/122/static/_content/27-line-4.png\" />\n            <img class=\"halfScaleC 27-sub-4\" style=\"top:99px; left:-92px;\" src=\"/122/static/_content/27-sub-4.png\" />\n\n            <h1 class=\"abs paris2024B 27-no\" style=\"top: 5px; left: 1px; font-size: 2.0em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\"data-number='{\"to\": 13}' ></h1>\n\n            <!-- Faith Row -->\n            <div class=\"abs\" style=\"top:-13px; left:-13px;\">\n              <div class=\"abs\" style=\"top:12px; left:5px;\">\n                <!-- <img class=\"halfScale 27-icon-4\" style=\"top:0px; left:0px;\" src=\"/122/static/_content/27-icon-4.png\" /> -->\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:34px;\" src=\"/122/static/_content/27-icon-4.png\" />\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:68px;\" src=\"/122/static/_content/27-icon-4.png\" />\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:102px;\" src=\"/122/static/_content/27-icon-4.png\" />\n                <!-- <img class=\"halfScale 27-icon-4\" style=\"top:0px; left:136px;\" src=\"/122/static/_content/27-icon-4.png\" /> -->\n              </div>\n\n              <div class=\"abs\" style=\"top:43px; left:5px;\">\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:0px;\" src=\"/122/static/_content/27-icon-4.png\" />\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:34px;\" src=\"/122/static/_content/27-icon-4.png\" />\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:68px;\" src=\"/122/static/_content/27-icon-4.png\" />\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:102px;\" src=\"/122/static/_content/27-icon-4.png\" />\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:136px;\" src=\"/122/static/_content/27-icon-4.png\" />\n              </div>\n\n              <div class=\"abs\" style=\"top:74px; left:5px;\">\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:0px;\" src=\"/122/static/_content/27-icon-4.png\" />\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:34px;\" src=\"/122/static/_content/27-icon-4.png\" />\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:68px;\" src=\"/122/static/_content/27-icon-4.png\" />\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:102px;\" src=\"/122/static/_content/27-icon-4.png\" />\n                <img class=\"halfScaleC 27-icon-4\" style=\"top:0px; left:136px;\" src=\"/122/static/_content/27-icon-4.png\" />\n              </div>\n            </div>\n          \n          </div>\n\n          <!-- Info5 -->\n          <div class=\"abs\" style=\"top:355px; left:26px;\">\n\n            <img class=\"halfScale 27-line-5\" style=\"top:1px; left:3px;\" src=\"/122/static/_content/27-line-5.png\" />\n            <img class=\"halfScaleC 27-sub-5\" style=\"top:28px; left:-40px;\" src=\"/122/static/_content/27-sub-5.png\" />\n            \n            <h1 class=\"abs paris2024B 27-no\" style=\"top: 3px; left: 4px; font-size: 2.0em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\"data-number='{\"to\": 4}' ></h1>\n\n            <!-- Buildings -->\n            <div class=\"abs\" style=\"top:-18px; left:-20px;\">\n              <img class=\"halfScaleC 27-icon-5\" style=\"top:67px; left:2px;\" src=\"/122/static/_content/27-icon-5.png\" />\n              <img class=\"halfScaleC 27-icon-5\" style=\"top:67px; left:48px;\" src=\"/122/static/_content/27-icon-5.png\" />\n              <img class=\"halfScaleC 27-icon-5\" style=\"top:111px; left:2px;\" src=\"/122/static/_content/27-icon-5.png\" />\n              <img class=\"halfScaleC 27-icon-5\" style=\"top:111px; left:48px;\" src=\"/122/static/_content/27-icon-5.png\" />\n            </div>\n          \n          </div>\n\n          <!-- Info6 -->\n          <div class=\"abs\" style=\"top:355px; left:163px;\">\n\n            <h1 class=\"abs paris2024B 27-no\" style=\"top: 2px; left: 0px; font-size: 2.0em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\"data-number='{\"to\": 1}' ></h1>\n\n            <img class=\"halfScale 27-line-6\" style=\"top:2px; left:0px;\" src=\"/122/static/_content/27-line-6.png\" />\n            <img class=\"halfScaleC 27-sub-6\" style=\"top:21px; left:-72px;\" src=\"/122/static/_content/27-sub-6.png\" />\n            <img class=\"halfScaleC 27-icon-6\" style=\"top:6px; left:-11px;\" src=\"/122/static/_content/27-icon-6.png\" />\n\n          </div>\n\n          <!-- Info7 -->\n          <div class=\"abs\" style=\"top:445px; left:163px;\">\n\n            <h1 class=\"abs paris2024B 27-no\" style=\"top: 0px; left: 50px; font-size: 2.0em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\"data-number='{\"to\": 227}' ></h1>\n\n            <img class=\"halfScale 27-line-7\" style=\"top:0px; left:0px;\" src=\"/122/static/_content/27-line-7.png\" />\n            <img class=\"halfScaleC 27-sub-7\" style=\"top:28px; left:6px;\" src=\"/122/static/_content/27-sub-7.png\" />\n            <img class=\"halfScaleC 27-icon-7\" style=\"top:-15px; left:-19px;\" src=\"/122/static/_content/27-icon-7.png\" />\n          \n          </div>\n\n          <!-- Info8 -->\n          <div class=\"abs\" style=\"top:533px; left:26px;\">\n\n            <img class=\"halfScale 27-line-8\" style=\"top:2px; left:2px;\" src=\"/122/static/_content/27-line-8.png\" />\n\n            <img class=\"halfScaleC 27-sub-8\" style=\"top:36px; left:-35px;\" src=\"/122/static/_content/27-sub-8.png\" />\n            <img class=\"halfScaleC 27-sub-9\" style=\"top:35px; left:133px;\" src=\"/122/static/_content/27-sub-9.png\" />\n            \n            <h1 class=\"abs paris2024B 27-no\" style=\"top: 0px; left: 3px; font-size: 2.0em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\"data-number='{\"to\": 10.67, \"decimals\":2, \"preppend\":\"EUR\"}' ></h1>\n\n            <h1 class=\"abs paris2024B 27-no\" style=\"top: 0px; left: 174px; font-size: 2.0em; font-weight:300; margin:0; color:#cdbb79; padding:0; margin:0;\"data-number='{\"to\": 400000, \"comma\":true, \"append\":\"+\"}' ></h1>\n\n          </div>\n          \n        </div>\n\n\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax({onComplete: addContentLinks});\n\n          pg27Anim.fromTo(cOf(\"27-title-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n\n\n          // INFO 1\n          pg27Anim\n            .fromTo(cOf(\"27-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[0]);}}, 1.4)\n            .fromTo(cOf(\"27-icon-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.3)\n            .fromTo(cOf(\"27-sub-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.3)\n            .fromTo(cOf(\"27-line-1\"), 0.8, {opacity:0, x:-5}, {opacity:1, x:0, ease: Power2.easeOut}, 1.2);\n\n          // INFO 2\n          pg27Anim\n            .fromTo(cOf(\"27-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[1]);}}, 1.9)\n            .fromTo(cOf(\"27-icon-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8)\n            .fromTo(cOf(\"27-sub-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8)\n            .fromTo(cOf(\"27-line-2\"), 0.8, {opacity:0, x:-5}, {opacity:1, x:0, ease: Power2.easeOut}, 1.7);\n\n          // INFO 3\n          pg27Anim\n            .fromTo(cOf(\"27-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[2]);}}, 2.4)\n            // .fromTo(cOf(\"27-icon-3\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.8)\n            .staggerFromTo(cOf(\"27-icon-3\"), 0.2, {opacity:0, scale:0}, {opacity:1, scale:0.5, ease: Power2.easeOut}, 0.03, 2.1)\n            .fromTo(cOf(\"27-sub-3\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2.1)\n            .fromTo(cOf(\"27-line-3\"), 0.8, {opacity:0, x:-5}, {opacity:1, x:0, ease: Power2.easeOut}, 2.0);\n\n          // INFO 4\n          pg27Anim\n            .fromTo(cOf(\"27-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[3]);}}, 2.7)\n            .staggerFromTo(cOf(\"27-icon-4\"), 0.2, {opacity:0, scale:0}, {opacity:1, scale:0.5, ease: Power2.easeOut}, 0.05, 2.6)\n            .fromTo(cOf(\"27-sub-4\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2.6)\n            .fromTo(cOf(\"27-line-4\"), 0.8, {opacity:0, x:-5}, {opacity:1, x:0, ease: Power2.easeOut}, 2.5);\n\n          // INFO 5\n          pg27Anim\n            .fromTo(cOf(\"27-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[4]);}}, 3.0)\n            .staggerFromTo(cOf(\"27-icon-5\"), 0.2, {opacity:0, scale:0}, {opacity:1, scale:0.5, ease: Power2.easeOut}, 0.05, 2.9)\n            .fromTo(cOf(\"27-sub-5\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2.9)\n            .fromTo(cOf(\"27-line-5\"), 0.8, {opacity:0, x:-5}, {opacity:1, x:0, ease: Power2.easeOut}, 2.8);\n\n          // INFO 6\n          pg27Anim\n            .fromTo(cOf(\"27-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[5]);}}, 3.3)\n            .fromTo(cOf(\"27-icon-6\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 3.2)\n            .fromTo(cOf(\"27-sub-6\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 3.2)\n            .fromTo(cOf(\"27-line-6\"), 0.8, {opacity:0, x:-5}, {opacity:1, x:0, ease: Power2.easeOut}, 3.1);\n\n          // INFO 7\n          pg27Anim\n            .fromTo(cOf(\"27-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[6]);}}, 3.6)\n            .fromTo(cOf(\"27-icon-7\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 3.5)\n            .fromTo(cOf(\"27-sub-7\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 3.5)\n            .fromTo(cOf(\"27-line-7\"), 0.8, {opacity:0, x:-5}, {opacity:1, x:0, ease: Power2.easeOut}, 3.4);\n\n          // INFO 8\n          pg27Anim\n            .fromTo(cOf(\"27-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[7]);}}, 3.8)\n            .fromTo(cOf(\"27-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[8]);}}, 3.9)\n            .fromTo(cOf(\"27-sub-8\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 3.8)\n            .fromTo(cOf(\"27-sub-9\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 3.9)\n            .fromTo(cOf(\"27-line-8\"), 0.8, {opacity:0, x:-5}, {opacity:1, x:0, ease: Power2.easeOut}, 3.7);\n\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n          resetNumbers(\"27-no\");\n          pg27Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  27  Issue 122  So things are in motion, but the Organising Committee wants to do even more, by completely changing people's attitudes. To bring sport and school closer together and get the education community to work with the sports movement throughout the school year, Paris 2024 launched the 'Génération 2024' label. This is given to the most committed schools, with numerous teaching resources and content available to teachers on a digital platform. Launched in 2017 at the instigation of Paris 2024, the national education ministry and the ministry of teaching and research, Olympic and Paralympic Week (SOP) is a key part of this mobilisation of the education community around sport and the civic values that are part of the Olympic and Paralympic DNA. Over the course of eight editions, the initiative has reached more than ﬁve million French students. Of these, almost 100,000 live in Seine-Saint-Denis. This department is a key part of the Games, as it hosts six of the competition venues, including the Stade de France, 11 training venues and the Olympic Village. It is also one of France's youngest and poorest departments, and the one most lacking in sports facilities. This is why, from the start of the candidature, Seine-Saint-Denis was placed at the heart of the material and social legacy of the Games.  Legacy and impact in Seine-Saint-Denis  5 20 public facilities renovated  homes created on the Athletes' and Media Village sites  13 hectares of green spaces cleaned up or created on the Terrain des Essences  4  1  schools created for 1,800 children  wooden bridge for cyclists and pedestrians linking Dugny, Le Bourget and Courneuve  Seine-Saint-Denis at the heart of the Games legacy The Aquatics Centre, a Greater Paris Council project built opposite the Stade de France, symbolises the ambition to organise Games that will beneﬁt the population. The Organising Committee wanted to make this project, the only sporting facility being built for the Games, a new centre of excellence for French swimming and leave a unique aquatic legacy for this area, where half of 11-year-olds have never learnt to swim. Including this new centre, there will be a total of 17 new pools in Seine-Saint-Denis, plus a refurbished facility. Parallel to this, in 2021, Paris 2024 and the Seine-Saint-Denis Departmental Council launched the '1,2,3 Swim!' programme enabling children, and their parents, to learn to swim free of charge. The involvement of the ANS, the French Swimming Federation, Paris 2024 Premium Partner Groupe EDF and several territorial authorities has taken this  4,000+  aquatics centres  227 'Impact 2024' projects supported  EUR 10.67  400,000+  million invested  direct beneficiaries"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 28-quote-1\" style=\"top:108px; left:480px;\" src=\"/122/static/_content/28-quote-1.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim.fromTo(cOf(\"28-quote-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n        }\n      ",
    "searchText": "28  Feature: Paris 2024 vision  by Paris 2024 and trialled in the town of Saint-Dizier, consists of creating playgrounds with structures and areas inspired by an innovative method known as 'active design', with a more equal space distribution for boys and girls to encourage mixing. In June 2023, the sports ministry created a dedicated fund, managed by the ANS, to speed up the roll-out and support the Terre de Jeux 2024 member communities implementing the initiative.  The Media Village will be a new neighbourhood that will revitalise the towns of Dugny and Le Bourget, including the renovation of eight sports facilities  Use sport and its positive impact for society  1  initiative to several cities around France each summer. The number of beneﬁciaries, mainly children aged from four to 12, has thus grown from 2,200 in 2021 to 26,400 in 2023, 9,400 of them in 27 towns in Seine-Saint-Denis. The Games have sped up urban renovation in the area to make it more attractive: 80 per cent of public investment totalling EUR 1.7 billion has gone to Seine-Saint-Denis. In 2025, the Olympic Village, an econeighbourhood spanning the communes of Saint-Denis, Saint-Ouen and Île-Saint-Denis and designed as a showcase for low-carbon 1 construction and consumption, will provide new homes for 6,000 new inhabitants, the same number of office workers, two schools and new shops. The Media Village will also be a new neighbourhood that will revitalise the towns of Dugny and Le Bourget, including the renovation of eight sports facilities, like the Pablo Neruda gymnasium in Saint-Ouen, which will provide a new gymnastics facility. The joint effort to leave a material Games legacy spans the whole country, with the French state having launched two huge investment programmes to build or renovate 10,000 sports facilities. The ﬁrst programme in early 2024 has already provided funding for 5,500 sports facilities, and the second will do the same, with an envelope of EUR 300 million over three years until 2026. Of these facilities, 1,500 will be gender-neutral active and sports schools. This initiative, launched  Schools again as a key driver. To get the country moving and anchor sport more ﬁrmly within society, Paris 2024 is looking further ahead. First by expanding the 30 minutes of daily physical activity initiative in towns and workplaces, particularly through active design planning. Then by highlighting the positive social impact of sport, using it as widely as possible to build the intangible legacy of the Games. Thanks to its endowment fund and 'Impact 2024' programme, the Organising Committee is supporting and funding projects throughout France that promote equal  2  1 The '1,2,3 Swim!' programme gives children free access to swimming pools. 2 Paris 2024 President Tony Estanguet has driven the campaign to get France moving."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "yane Sofyane Sofyan Mehiaoui e Mehi M ehiaou aouii Fra France France, nce,, Whee W Wheelchair heelch lchair air Basketball Baske Ba sketba tballll Team Visa  Sky ky Br Brown o Great at Bri Britain, Skateboarding Britai G Gre tain, n, Ska Skateb teboar oardin ding Team Visa Tokyo 2020  Noah Noa hL Lyles Lyle yle USA, A Athletics Visa Team V  ©2021: IOC / Ian MacNicol / Getty Images / All rights reserved  Excellence begins with a series of small actions. Visa is a proud sponsor of the Olympic and Paralympic Games"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 30-quote-1\" style=\"top:568px; left:477px;\" src=\"/122/static/_content/30-quote-1.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.fromTo(cOf(\"30-quote-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n        }\n      ",
    "searchText": "1  1  access to physical activity and sport, and use the social impact of sport to promote health, education, inclusion and the environment. Since 2020, more than 4.5 million people have been directly impacted through over 1,000 projects, supported with EUR 47.8 million distributed to the people involved  2  on the ground, with EUR 16.6 million coming from the endowment fund alone. Seine-SaintDenis is one of the key areas for action, accounting for over 20 per cent of the projects supported and, with nearly EUR 11 million invested, almost 19 per cent of the total funding. More than 400,000 direct beneﬁciaries of the endowment fund live in this department. Among the projects supported in Seine-Saint-Denis, 54 per cent are intended to promote equality, solidarity and inclusion. The Paris 2024 legacy for the department is also aimed at increasing accessibility to sports activities for people with disabilities. As well as the new neighbourhood created by the Olympic Village, which incorporated universal accessibility right from the design phase, new facilities have been created at Bobigny thanks to the reinforcing effect of the Games: one example is the Greater Paris  'The Games will have a snowball effect. The newcomers will be our best ambassadors, leading others to take up sport' Michel Cymès, Paris 2024 Health Ambassador  1 Olympic and Paralympic Week has reached almost 100,000 children living in Seine-Saint-Denis. 2 The Olympic Village will provide new homes for 6,000 inhabitants. 3 Participation in para sports has been boosted by the Paris 2024 'Inclusive Club' programme."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  Inclusive Sport Reference Centre (PRISME). Built using universal design principles, this will be a training venue for the Paralympic Games and will become a focal point in France for para sport, for elite and amateur athletes alike. In addition, in 2020, Paris 2024 - with its endowment fund, the French Paralympic Committee (CPSF) and the City of Paris - launched the 'Inclusive Club' programme, which enables clubs to create a dedicated para sport section. After an initial trial in Paris,  3  31  Issue 122  Seine-Saint-Denis was a priority area for testing and then rolling out this programme, which has since expanded across the country thanks to the support of the sports ministry. The target, set by President Macron, is to reach 3,000 inclusive clubs in France by the end of 2024. Other projects supported are using sport to mobilise and integrate unemployed people, such as 'Inser'sport Seine-Saint-Denis', which has already beneﬁted 2,000 people since its launch at the end of 2022. To 'open  wide' the economic opportunities of the Games, in addition to the ﬁrst social charter in the history of the Games, signed by Paris and its social partners, several other tools have been put in place. The 'ESS 2024' platform, for instance, has facilitated access to Games contracts for ﬁrms in the social economy (ESS), particularly in Seine-Saint-Denis, where 42 contracts are in place with 27 local ESS ﬁrms.  A legacy long after 2024 Whether by investing massively in sports facilities or calling for daily physical activity in schools, the French state has decided to make full use of the opportunity that the Games represent for the whole country, making sport the national 'Grande Cause' (public interest campaign) for 2024. 'The Games help you get into people's consciousness. The message gets across and they act on it. The Grande Cause will help to amplify the dynamic still further and ensure that this message is conveyed until December 2024 and long after the Games,' Cymès explains. 'We're not going to stop there!' The impetus created by the Paris 2024 teams will thus be extended across the country, which is vital for achieving radical social transformation. 'In schools, the daily 30 minutes of physical activity are under way, and we're moving in the right direction,' Cymès says. 'If this works out, we'll have won over a whole generation of children now aged from ﬁve to 11. And we know that this is the time that really matters.' Ndongue is equally optimistic: 'Getting a whole country moving demands both energy and compromise. But when we see the success of the Olympic and Paralympic Week, the use of sports kits in schools and raising awareness of the Paralympic Games among schoolchildren, I think we've started something. Each time pupils tell me they feel better from doing sport, each time I see them smiling and having fun, I feel a great sense of satisfaction.' To build a lasting legacy and create a long-term dynamic, Paris 2024 has innovated by starting to assess the various actions taken and their impact even before the Games. This is true especially for the 30 minutes of physical activity in schools, on which a qualitative study was carried out in 2020 and 2021 by teachers in the Créteil academy,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 32-quote-1\" style=\"top:777px; left:44px;\" src=\"/122/static/_content/32-quote-1.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim.fromTo(cOf(\"32-quote-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop();\n        }\n      ",
    "searchText": "32  Feature: Paris 2024 vision  1  2  1  where the initiative was trialled. The study conﬁrmed the positive effects of physical activity on the pupils. The assessment, carried out by the Organising Committee, with the IOC and the Sports Law and Economics Centre in Limoges following recommendations from the Organisation for Economic Co-operation and Development (OECD), is being supervised by an assessment monitoring committee. Several reports have already been issued, with a ﬁnal update due to be published after the Games. Cymès already has no doubts about the positive impact: 'We'll be able to accurately measure the legacy and success of the Games through these studies. And if there is only a 10 per cent increase in physical activity, that will already be a big win. Because I'm convinced that the Games will have a snowball effect: the newcomers will be our best ambassadors, leading others to take up sport.' And to ensure that this is a lasting legacy, Paris 2024 has already planned ahead: handing them over to the state and the sports movement will ensure that the programmes with the biggest impact continue. 'When we launched them, we'd already planned for the programmes to be taken over by some of our stakeholders. They committed to continue the programmes started with Paris 2024,' explains Marie Barsacq, Paris 2024's Executive Director for Impact and Legacy. 'Thanks to our exchanges with previous host cities and the IOC, we took this aspect into account very early on and prepared the handover more than four months before the Games.' Will Paris 2024 be the start of a new era for sport and those who practise it in France? 'Above and beyond the performances by the athletes during the Games, the key is knowing how to use all this sport to bring together, onboard, educate, protect and carry as many people as possible. The Games bring people together, and that's how they have a social impact,' Ndongue explains. And if the Winter Games are held in France in 2030, this will go even further. ■  ' We'd already planned for the programmes to be taken over by our stakeholders. They committed to continue the programmes started with Paris 2024' Marie Barsacq, Paris 2024 Executive Director for Impact and Legacy  1 French rugby pioneer Odette Desprats takes part in the Olympic Torch Relay."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Get ready  for real precision Soﬁa, Olympic Athlete, Team Allianz"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 34-line-1\" style=\"top:93px; left:-89px;\" src=\"/122/static/_content/34-line-1.png\" />\n        <img class=\"halfScale 34-icon-1\" style=\"top:74px; left:39px;\" src=\"/122/static/_content/34-icon-1.png\" />\n        <img class=\"halfScale 34-title-1\" style=\"top:123px; left:44px;\" src=\"/122/static/_content/34-title-1.png\" />\n\n        <!--Linky-->\n        <div class=\"addContentLinkThree\" style=\"top:248px; left:43px; width:60px; height:15px;\">\n        <a href=\"https://olympics.com/ioc/news/paris-2024-appoint-thomas-jolly-as-artistic-director-for-opening-and-closing-ceremonies\" target=\"_blank\"></a>\n        </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.fromTo(cOf(\"34-line-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n          pg34Anim.fromTo(cOf(\"34-icon-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.1);\n          pg34Anim.fromTo(cOf(\"34-title-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1.2);\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "34  Feature: Paris 2024 vision  2  A CELEBRATION OF OUR Thomas Jolly, Artistic Director for the Opening and Closing Ceremonies of the Olympic and Paralympic Games Paris 2024, is embracing the opportunities, and challenges, that come from opening the Games in the heart of the city  How does the Olympic Games Opening Ceremony fit with Paris 2024's overall ambition and how will it make history? 'The Opening Ceremony of the Olympic Games Paris 2024 will be different from the previous 1 because of its unusual ones setting: for the ﬁrst time ever, it will not take place inside a stadium. The Seine, the vibrant emblem of Paris, will be the setting for this celebration, offering the chance to host people in the heart of the city, in an unprecedented mixture of team parade and artistic moments. Holding it outside and breaking with the traditional structure of past ceremonies ﬁt in with the overall desire of the Paris 2024 organisers to make the Games open to everyone. Because it features so many rsts, IRiner hope willto 1 WillﬁTeddy beitable go down addin a ﬁhistory.' fth Olympic medal to his collection? 2 Mélina Robert-Michon will compete in her seventh edition of the Games.  What is the main message you want to get across? 'First of all, I'd like to show France in all its diversity. Illustrate the richness and plurality shaped by its history, which has been inﬂuenced and inspired by the diverse cultures that have passed through it, while itself serving as a source of inspiration. The Opening Ceremony is also a snapshot of the world on a speciﬁc day: 26 July 2024. So I want this to be an opportunity for us to look at each other and celebrate our shared humanity, while taking into account the issues we currently have to face.'  What is the biggest challenge you face as Artistic Director? 'It's an incredible artistic challenge! I'm lucky to have the most magniﬁcent setting, with the Seine that occupies a unique position in the history of Paris and, more broadly, of France. But I have to deal with the current of the river, protect the heritage, check the resonance of the bridges, adjust the scenario that we have created to the reality of the river and stick to the budget; but also be careful of the ﬁsh spawning and deal with the sunlight, my main light source, which is ironic for someone used to the darkness of theatres and opera houses. Every day I face the challenge of multiple technical constraints, but what show doesn't have those? Creating a show is about matching dreams and reality. In less pragmatic terms, my main challenge is living up to the event itself - and celebrating the return of the Olympic Games to Paris after a century-long wait.'"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Not for minors."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 36-title-1\" style=\"top:675px; left:43px;\" src=\"/122/static/_content/36-title-1.png\" />\n        <img class=\"halfScale 36-title-2\" style=\"top:720px; left:44px;\" src=\"/122/static/_content/36-title-2.png\" />\n        <img class=\"halfScale 36-sub-1\" style=\"top:785px; left:44px;\" src=\"/122/static/_content/36-sub-1.png\" />\n\n        <!--Linky-->\n        <div class=\"addContentLinkThree\" style=\"top:578px; left:503px; width:61px; height:15px;\">\n          <a href=\"https://olympics.com/ioc/ms-sarah-walker\" target=\"_blank\"></a>\n        </div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim.fromTo(cOf(\"36-title-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n          pg36Anim.fromTo(cOf(\"36-title-2\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.1);\n          pg36Anim.fromTo(cOf(\"36-sub-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1.2);\n\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "36  Feature: Urban spirit  P  EMBRACING THE  URBAN SPIRIT  THE OLYMPIC GAMES PARIS 2024 ARE SET TO BE THE MOST DYNAMIC AND INNOVATIVE TO DATE, BOASTING AN EXCITING AND YOUTH-FOCUSED PROGRAMME, WITH SEVERAL NEW SPORTS TAKING PLACE IN AN URBAN SETTING. BY NANCY GILLEN  lace de la Concorde will be the unique backdrop for a number of fast-paced and exciting urban sports during Paris 2024, with the spectacular city-centre location set to help the Olympic Games become more inclusive and accessible than ever before. The iconic venue will become an urban sports hub for the Games - the Concorde Urban Park - hosting skateboarding, BMX freestyle, 3×3 basketball and breaking alongside a packed programme of concerts, exhibitions and sports demonstrations. The unique city-centre setting, which will welcome up to 37,000 people during Paris 2024, takes inspiration from the successful use of urban parks at the Olympic Games Tokyo 2020 and the Youth Olympic Games Buenos Aires 2018. Located close to other competition venues, the Concorde Urban Park has accessibility at its heart, giving as many people as possible the chance to witness spectacular sports at close quarters. 'Transforming the Place de la Concorde into an urban park for Paris 2024 will provide an incredible platform for these exhilarating sports,' said Sarah Walker, Olympian and IOC Athletes' Commission member. 'Being in the heart of the city, the athletes will be able to feel the fans' excitement and showcase their skills against such an amazing urban backdrop.' Skateboarding, BMX freestyle and 3×3 basketball all return after thrilling debuts at Tokyo 2020, while breaking will feature on the programme for the ﬁrst time. Two other sports that made their debut in Tokyo - sport climbing (Le Bourget Sport Climbing Venue) and surﬁng (Teahupo'o, Tahiti) - will also return, aligning with the ambition set out by Paris 2024 and the International Olympic Committee to make the Games more inclusive and accessible, and to appeal to a more youthful audience."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n\n      ",
    "script": "\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n\n        <div class=\"addContentLinkThree\" style=\"top:32px; left:490px; width:165px; height:31px;\">\n        <a href=\" https://olympics.com/en/paris-2024/venues\" target=\"_blank\"></a>\n        </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){addContentLinks();}, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Skateboarding Skateboarding, synonymous with the rebellious and thrill-seeking values of 1980s underground culture, is now one of the most accessible and popular sports among young people. The Olympic competition will feature two spectacular disciplines - park and street - with athletes judged on their ability to execute a range of impressive tricks.  BMX freestyle BMX freestyle is cycling's most electrifying discipline. Riders, who must perform as many tricks as possible in 60 seconds, are scored based on the difficulty of their moves, height of their jumps and creativity of their routines.  Sport climbing Sport climbing requires a fascinating mix of speed, strength, agility and quick thinking. Three formats will be on display at Paris 2024, namely boulder, lead and speed. Champions will be crowned in a boulder and lead combined event, as well as a speed event.  3x3 basketball A creative and fast-paced variation of one of the world's most popular sports, 3×3 basketball is played on a half court with both teams attacking and defending the same hoop. The winner is the team with the highest score at the end of the 10-minute period or the ﬁrst team to reach 21 points.  Breaking Breaking will make its Olympic debut at Paris 2024, bringing urban ﬂair to the French capital. Athletes will go head-to-head in spectacular solo dance battles, pulling off a range of moves in an attempt to wow the judges.  Surfing France's rich and diverse heritage will be on show during the Olympic surﬁng competition on the waves of Teahupo'o, in Tahiti. Surfers are scored based on the variety, type and difficulty of their tricks, as well as their speed, power and ﬂow."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 40-title-1\" style=\"top:722px; left:43px;\" src=\"/122/static/_content/40-title-1.png\" />\n        <img class=\"halfScale 40-title-2\" style=\"top:720px; left:44px;\" src=\"/122/static/_content/40-title-2.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.fromTo(cOf(\"40-title-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n          pg40Anim.fromTo(cOf(\"40-title-2\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.05);\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n        }\n      ",
    "searchText": "40  Feature: Excitement around Paris 2024  OLYMPISM WITH A FRENCH FLAVOUR"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 41-sub-1\" style=\"top:748px; left:44px;\" src=\"/122/static/_content/41-sub-1.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim.fromTo(cOf(\"41-sub-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  41  Issue 122  Excitement continues to build among the French public ahead of Paris 2024.  A THREE FRENCH SPORTS PERSONALITIES AND OLYMPIC GOLD MEDALLISTS REVEAL WHY THEY ARE EXCITED ABOUT PARIS 2024 AND WHAT IT MEANS TO HOST THE GAMES IN THEIR HOME COUNTRY. AS TOLD TO ALAIN MERCIER  lain Mercier is a French journalist based in Asia, where he covers Olympic news for the website FrancsJeux. After starting his career at L'Équipe, followed by stints at Sport and Libération, he set up the press agency Alinéa and opened offices in the United States prior to the Olympic Games Atlanta 1996, and in Australia prior to Sydney 2000. He has covered every edition of the Olympic Games, winter and summer, since Seoul 1988 (with the exception of Vancouver 2010), either for the written press, television or agencies. Paris 2024 will be his 19th edition of the Games as a journalist."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 42-title-1\" style=\"top:147px; left:77px;\" src=\"/122/static/_content/42-title-1.png\" />\n        <img class=\"halfScale 42-sub-1\" style=\"top:219px; left:76px;\" src=\"/122/static/_content/42-sub-1.png\" />\n\n        <!--LINKY-->\n        <div class=\"addContentLinkThree\" style=\"top:216px; left:158px; width:61px; height:15px;\">\n          <a href=\"https://olympics.com/fr/athletes/laura-flessel-colovic\" target=\"_blank\"></a>\n        </div>\n\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim.fromTo(cOf(\"42-title-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n          pg42Anim.fromTo(cOf(\"42-sub-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "42  Feature: Excitement around Paris 2024  A NEW IMAGE OF WOMEN'S SPORT' Fencing champion Laura Flessel believes Paris 2024 will provide the perfect platform to showcase female athletes, coaches and referees  You were Sports Minister when the IOC awarded the 2024 Games to Paris. What is your memory of the Session in Lima in September 2017?  T  he ﬁgures don't lie. Laura Flessel, France's most famous female fencer, was at six consecutive editions of the Olympic Games. The ﬁrst ﬁve as an athlete, from Atlanta 1996 to London 2012, winning ﬁve medals in the épée events, two of them gold. The sixth as a coach, at Rio 2016. Named France's Sports Minister in May 2017, she was there for the ﬁnal months of Paris's candidature to host the 2024 Games. Then she played a big role in the creation of the Organising Committee (OCOG), and the adoption of the Olympic law by parliament. Almost a whole lifetime linked to the Olympic Games. And a voice that carries weight when it comes to Paris 2024, its preparation and legacy.  It's still fresh in my mind, almost seven years later. The memory of a big moment, especially the ﬁnal meetings before the Session. When we went to Lima, we weren't 100 per cent sure we'd be bringing the Games back to France, after the many previous failures. But back to the official announcement. I was representing sports governance, but also the athletes and volunteers. I felt like the mediator between the sports movement, the state and the local communities.  You were still Sports Minister when the Paris 2024 OCOG started out. What was the most important thing for you at that time? The priority was very institutional, as we needed to get the National Assembly and then the Senate to approve the creation of the OCOG but also SOLIDEO, the public body overseeing the building of Olympic infrastructure. A painstaking job, but essential in order to  have a free rein afterwards. And then we had to create an organisation chart.  Can the Paris 2024 Games change the place of sport in French society?  Of the five Olympic Games that you experienced as an athlete, which edition do you feel most closely resembled the image you have of Olympism?  Sport is an amazing tool for integration and inclusion, but also for health and well-being. Paris 2024 will be a showcase for this, as it speaks to everyone. Today, one child in three is overweight. You can sense a kind of malaise in society. The Games can't perform miracles, but they can channel the beneﬁts of sport and physical activity. The Paralympics will also play a big role in promoting sport for people with disabilities. Look at gyms, for example. They're accessible now, but sorely lacking in equipment that people with reduced mobility can use.  Sydney 2000, no question. A real celebration of sport, for the athletes, the media and the Olympic family. The Australians welcomed the world with a big smile, and we felt like honoured guests from start to ﬁnish. They were also highly professional. For us athletes, everything went smoothly. In the Village, nothing was impossible. There was always a solution. I didn't win a gold medal there, but Sydney 2000 will always be in my heart.  Paris 2024 will be the first Games to have an equal number of male and female medallists. Will we see the effects of this parity on women's sport?  This won't be a novelty for anyone of a certain age, as France organised the World Championships there in 2010. It's a super venue. Many former champions have worked on the preparations for the Games, including Brice Guyart, the Olympic individual foil gold medallist in 2004. They know their stuff. And we'll have a very good French team for all the weapons.  Sport has long been a male-dominated affair. Things are evolving, but there's still a lot of ground to cover. Paris 2024 will show a new image of women's sport and female athletes. The image of women who are both mothers and champions. Many women still see sport as a purely curative activity. With the Games, they'll realise that it's much more than that. Paris 2024 will highlight female champions, but also coaches and referees.  A word about fencing, which will be staged in the Grand Palais. What do you think the competitions will be like?  1 Flessel competing at the Olympic Games London 2012 in épée."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 43-quote-1\" style=\"top:143px; left:311px;\" src=\"/122/static/_content/43-quote-1.png\" />\n\n        <!--VIDEO-->\n        <img class=\"abs halfScaleC halfpulse animatedpulse pointer\" style=\"top:62px; left:-3px;\" src=\"/122/static/_content/white-play.png\"  onclick=\"Publish.updateVideoURL('https://www.youtube.com/embed/L8W5emi0PPM?si=i8ffZJtb34Jf4jon')\"/>\n\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax();\n          pg43Anim.fromTo(cOf(\"43-quote-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg43Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  1  43  Issue 122  ' Sport is an amazing tool for integration and inclusion, but also for health and well-being. Paris 2024 will be a showcase for this' Laura Flessel"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 44-title-1\" style=\"top:148px; left:74px;\" src=\"/122/static/_content/44-title-1.png\" />\n        <img class=\"halfScale 44-sub-1\" style=\"top:182px; left:76px;\" src=\"/122/static/_content/44-sub-1.png\" />\n\n        <!--LINK-->\n        <div class=\"addContentLinkThree\" style=\"top:178px; left:224px; width:64px; height:15px;\">\n          <a href=\"https://olympics.com/fr/athletes/alain-bernard\" target=\"_blank\"></a>\n        </div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg44Anim = new TimelineMax();\n          pg44Anim.fromTo(cOf(\"44-title-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n          pg44Anim.fromTo(cOf(\"44-sub-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg44Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "44  Feature: Excitement around Paris 2024  SEIZE THE MOMENT' Olympic swimming gold medallist Alain Bernard believes Paris 2024 could be transformative for the sport in France  What will you be doing during the Games in Paris?  H  is list of achievements explains why he is held in such esteem, within French swimming in particular and French sport generally: four Olympic medals, two of them gold. Top of the list is the 100m freestyle title at the Olympic Games Beijing 2008. The ﬁrst - and still the only - Frenchman to achieve this. Now 41, Bernard retired from swimming nearly 10 years ago. But not from the pool, and he'll be at Paris 2024: an event he believes will have a big impact on French swimming, both in the short term and in the future.  I'm lucky to be able to experience them from the inside. I'll be working for Eurosport as a consultant for the swimming events. I'll be giving technical explanations, like why a particular swimmer is fast and why another isn't doing as well. During the second week of the Games, I'll be there for public relations work with a partner, and will do the same at the Paralympics.  Is being a consultant for a broadcaster a new role for you? No. I started at Rio 2016, a year after ending my swimming career. At Tokyo 2020, I did the commentary from a box in Paris. Not ideal. Paris 2024 looks like being a totally different affair, with an amazing level of excitement. I was lucky to be there when the Torch Relay started in Marseille, on 8 May, and I could see just how excited the public were. I think the start of the relay in France really launched Paris 2024 for the French.  Have you been involved in the Paris 2024 preparations? I've been working for several years with a company based in Montpellier, in south-east  France, Vogo Sport, which specialises in video for sport. We've developed a system that analyses movement and technique, which is installed in the Olympic Aquatics Centre in Saint-Denis. It's used particularly by divers who want to better analyse their performance. Through this project, I'm very proud to have helped move the sport forward.  For the first time in their careers, French swimmers will get to experience the Olympic Games in their own country. Does that make it a totally different experience? A lot will be expected of them, so they'll be under that extra bit of pressure. Having the event in your own country provides an extra layer of emotion. But a high-level athlete always tries to do their best, whichever country they're in. The Olympic Games are the culmination of years of work, and for swimming, they last just eight days. That's both a very long and a very short time. You need to know how to seize the moment, savour the experience to the full, get caught up in the emotion but not lose your focus and miss your chance. It's a tough balance to strike.  What do you think of the competition venues for swimming that the Paris 2024 organisers have chosen? The organisers are really placing the Games in the heart of the city. The venue choice for the aquatic  disciplines, with swimming and water polo at the Défense Arena, open water swimming in the Seine, and artistic swimming, diving and some water polo at the new Olympic Aquatics Centre, is very well thought out. It'll offer a larger number of competition venues, with different experiences for the spectators. The Défense Arena will have a real cauldron atmosphere. The Aquatics Centre will have a second life after the Games, as a venue for other sports like padel and climbing. As for the River Seine, these Games have really sped up the efforts to make it safe to swim in. Without them, the clean-up work may possibly never have been done.  Can Paris 2024 change French swimming for ever? Up till now, swimming has been very scattered geographically, with no central point. Going forward, the Olympic Aquatics Centre will play this role. It's already been decided that France will hold the European Championships there in 2026. Two years after Paris 2024, this 'second coat' will give swimming more visibility. All that should help to develop the sport. I hope that, after the Games, there'll be lots of young French people who go to a pool and take up swimming, in one form or another.  1 Bernard celebrates his victory in the 100m freestyle at Beijing 2008."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 45-quote-1\" style=\"top:688px; left:322px;\" src=\"/122/static/_content/45-quote-1.png\" />\n\n        <!--LINK-->\n        <div class=\"addContentLinkThree\" style=\"top:806px; left:330px; width:106px; height:15px;\">\n          <a href=\"https://olympics.com/fr/infos/alain-bernard-20-ans-de-travail-condense-en-47-secondes\" target=\"_blank\"></a>\n        </div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax();\n          pg45Anim.fromTo(cOf(\"45-quote-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg45Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Review  45  Issue 122  1  ' You need to know how to seize the moment, savour the experience to the full, get caught up in the emotion but not lose your focus and miss your chance' Alain Bernard"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 46-title-1\" style=\"top:147px; left:74px;\" src=\"/122/static/_content/46-title-1.png\" />\n        <img class=\"halfScale 46-sub-1\" style=\"top:219px; left:76px;\" src=\"/122/static/_content/46-sub-1.png\" />\n\n        <!--Linky-->\n        <div class=\"addContentLinkThree\" style=\"top:219px; left:344px; width:39px; height:12px;\">\n          <a href=\"https://olympics.com/fr/athletes/romane-dicko\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLinkThree\" style=\"top:232px; left:75px; width:30px; height:12px;\">\n          <a href=\"https://olympics.com/fr/athletes/romane-dicko\" target=\"_blank\"></a>\n        </div>\n\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg46Anim = new TimelineMax();\n          pg46Anim.fromTo(cOf(\"46-title-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n          pg46Anim.fromTo(cOf(\"46-sub-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg46Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "46  Feature: Excitement around Paris 2024  A HUGE CELEBRATION FOR EVERYONE' After winning two medals at the Olympic Games Tokyo 2020, Romane Dicko has had her sights ﬁrmly set on Paris 2024 - seven days a week  Do you remember your reaction when Paris was chosen to host the Games, in September 2017 at the IOC Session in Lima?  R  omane Dicko was 17 when Paris was chosen to host the 2024 Olympic and Paralympic Games. She will soon be 25. The age when an Olympic gold medal is no longer just a dream. The French judoka, who won a bronze medal in the +78kg category at Tokyo 2020 - plus a gold in the mixed team event - makes no secret of her ambitions. Victory. Nothing less will do. Born in the Ile-de-France region and a member of the Paris Saint-Germain Judo Club, Dicko is eagerly looking forward to Paris 2024. She is expecting the Games to be the high point of her career, but also a huge celebration. And a leap forward for sport in French society.  I was 17 and still a junior, but already training at INSEP (the National Institute for Sport, Expertise and Performance). I remember the announcement very well. We were all watching the television in the cafeteria, following the ceremony live. I hadn't yet won anything at senior level, so Paris 2024 was like a dream for me. But at the same time not such a distant one.  Since then, what role has Paris 2024 played in your journey as an athlete, your thoughts and your everyday life? To start with, I didn't think about them at all. But when I began getting results at senior level, I realised that this dream was becoming achievable. So Paris 2024 occupied an increasingly big place in my life. After Tokyo 2020, I told myself that the Olympic title was within my grasp. Since then it's been inside my head, and I can't stop thinking about it. It takes my energy seven days a week. I won the [individual]  bronze in Tokyo, and now I want the gold. Competing at more than one edition of the Games is already a huge privilege, but doing so in your own country is an incredible opportunity.  Have you been directly or indirectly involved in the preparations for the Games? No, and it's much better that way. I don't think it's the job of active athletes to get involved in the Games preparations. We've got a National Olympic Committee that's done a great job. We've been able to keep out of it and focus on what's essential for us.  Is it very different preparing for the Olympic Games in your own country? In sporting terms, no. The Games are still the Games, the top competition. But as a French athlete, you have to be mentally ready, as the excitement will be immense. No athlete is ever really prepared for such an experience. That's why I've been focusing part of my preparation on this aspect of the competition since Tokyo 2020. I've worked on it speciﬁcally with my mental performance coach several times a month. I want to be as strong as possible inside my head.  Other than your own performance, what are you expecting from these Games? A huge celebration for everyone. We were deprived  of that in Tokyo because of the health situation, so I want to share the experience with other athletes, the public and the media. Happy Games; Games that do some good. An event where all the values of sport and Olympism will be combined.  Can Paris 2024 change the place of sport in society? I hope so. And I have the impression that this is already happening. Sport has a higher proﬁle in schools and is more often linked with health and well-being. Even before it starts, Paris 2024 has brought sport into French people's daily lives. In judo, we have a bigger number of licence-holders (more than 500,000), but the impact may be even greater. After Tokyo 2020, we saw many people joining clubs. If we win a lot of medals in Paris, the effect will be even bigger. And that'll be brilliant, as judo teaches a lot of educational values. I'd so much like to see thousands of children getting into judo and growing up with the sport.  1 Dicko won gold and bronze in the mixed team and +78kg events respectively at Tokyo 2020."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 47-quote-1\" style=\"top:153px; left:219px;\" src=\"/122/static/_content/47-quote-1.png\" />\n\n\n        <!--VIDEO TODO: FIXME: PLS-->\n        <a class=\"abs\" href=\"https://olympics.com/fr/video/romane-dicko-judo-france-mixed-team-gold-stronger-together\" target=\"_blank\">\n          <img class=\"abs halfScaleC halfpulse animatedpulse pointer\" style=\"top:66px; left:0px;\" src=\"/122/static/_content/white-play.png\")\"/>\n\n          <!--<img class=\"abs halfScaleC halfpulse animatedpulse pointer\" style=\"top:66px; left:0px;\" src=\"/122/static/_content/white-play.png\"  onclick=\"Publish.updateVideoURL('https://olympics.com/en/video/romane-dicko-judo-france-mixed-team-gold-stronger-together')\"/>-->\n        </a>\n\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim.fromTo(cOf(\"47-quote-1\"), 0.8, {opacity:0, x:-40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg47Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  1  47  Issue 122  'After Tokyo 2020, I told myself that the Olympic title was within my grasp. Since then it's been inside my head, and I can't stop thinking about it' Romane Dicko"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 48-title-1\" style=\"top:56px; left:41px;\" src=\"/122/static/_content/48-title-1.png\" />\n        <img class=\"halfScale 48-sub-1\" style=\"top:229px; left:42px;\" src=\"/122/static/_content/48-sub-2.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim.fromTo(cOf(\"48-title-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n          pg48Anim.fromTo(cOf(\"48-sub-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n        }\n      ",
    "searchText": "A UNIQUE PATH TO PARIS OLYMPIC REVIEW EXAMINES THE STORIES OF THREE TALENTED ATHLETES SUPPORTED BY OLYMPIC SOLIDARITY, GIVING THEM THE TOOLS TO PREPARE FOR THE OLYMPIC GAMES"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n\n        <!--LINKY-->\n        <div class=\"addContentLinkThree\" style=\"top:273px; left:532px; width:64px; height:12px;\">\n        <a href=\" https://olympics.com/ioc/news/tasi-limtiaco-putting-micronesia-swimming-on-the-map-at-paris-2024\" target=\"_blank\"></a>\n        </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){addContentLinks();}, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "T Arshad Nadeem was the ﬁrst Pakistani to qualify for an Olympic ﬁnal in any track and ﬁeld event.  asi Limtiaco, Edda Hannesdóttir and Arshad Nadeem grew up thousands of miles away from each other and compete in different sports, but they all have something in common. All three are hoping to make their mark at the Olympic Games Paris 2024 with the support of Olympic Solidarity scholarships, which have allowed them to reach new heights despite coming from countries unable to put signiﬁcant resources into their respective sports. Tasi Limtiaco, who represents the Federated States of Micronesia on the international stage, grew up on the nearby island of Guam. He overcame the odds to forge a successful swimming career, competing at Tokyo 2020 and earning three gold medals at the 2023 Paciﬁc Games. 'We didn't have many resources in Guam,' Limtiaco explains. 'The pool that I grew up practising in was a short 15-metre hotel pool. 'I would say that, especially for Guam and Micronesia, it's a little bit too easy to reach the top and become the best. It was still a great experience - not to look down on Guam or anything. But there were deﬁnitely not as many opportunities to reach your full potential.'"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 50-quote-1\" style=\"top:110px; left:478px;\" src=\"/122/static/_content/50-quote-1.png\" />\n\n        <!--LINKY-->\n        <div class=\"addContentLinkThree\" style=\"top:418px; left:41px; width:84px; height:15px;\">\n          <a href=\"https://olympics.com/ioc/news/edda-hannesdottir-set-to-make-history-as-first-triathlete-from-iceland-to-compete-at-olympic-games \" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLinkThree\" style=\"top:609px; left:127px; width:74px; height:15px;\">\n          <a href=\"https://olympics.com/ioc/news/arshad-nadeem-the-javelin-thrower-making-athletics-history-for-pakistan-now-aiming-for-a-medal-at-paris-2024 \" target=\"_blank\"></a>\n        </div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg50Anim = new TimelineMax();\n          pg50Anim.fromTo(cOf(\"50-quote-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg50Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "50  ' I try not to take it for granted - I really feel like I appreciate the support and it's amazing to have access to this coming from a smaller country' Edda Hannesdóttir  1  Edda Hannesdóttir had a similar experience as a triathlete in Iceland, with the lack of support meaning she often had a trickier experience preparing for competition. 'Coming from a smaller country that doesn't have a lot of public funding for sports, I've had to ﬁgure out my own support team,' she says. 'That has taken some time. 'I've had to plan all my competitions myself, buy the ﬂights, the hotels and everything. Coming from a smaller country, it will always be a little bit more stressful. If you're not able to manage that, it can manifest in being anxious or nervous before the race.' While Pakistan's Arshad Nadeem is a medal favourite for the javelin competition at Paris 2024, having earned silver at the 2023 World Athletics Championships, his journey to the top has not been easy. He has encountered the same challenges as Limtiaco and Hannesdóttir, but like his fellow athletes the strains of trying to forge a career in elite sport while coming from an under-resourced country have been softened by the support from Olympic Solidarity. 'The support through the scholarship has been a great help with a lot of things  1 At Paris 2024, Edda Hannesdóttir will be the ﬁrst Icelander to appear at the Games in triathlon. 2 The Olympic Solidarity scholarship has supported her for years, aiding her comeback from injury.  that were needed - a lot of things that were rudimentary to javelin throwing and athletics,' Nadeem says. 'It has helped me towards achieving my goals. I hope the programme will continue for the next generation of Olympic athletes.' Limtiaco has been able to move to the United States, giving him a training location where he will be able to reach his full potential. 'I wouldn't be here in San Diego without Olympic Solidarity - living in California is a little bit pricey,' he says.  2  'Getting that ﬁnancial support helps with commuting back and forth, paying team fees and getting new racing suits. Some athletes have to pick up multiple jobs just to support themselves, but Olympic Solidarity has deﬁnitely helped me out with that.' Meanwhile, Hannesdóttir, who has recently returned from a major injury, has been able to travel around the world with a support team to collect enough ranking points for Paris 2024. 'There's no chance I would be able to do this without the support of the Olympic Solidarity scholarship,' she makes clear. 'So, for me to have access to something like Olympic Solidarity means that I am actually able to not work a lot or even work at all, and I'm able to just focus on what I need to do to be ﬁt and ready. 'I try not to take it for granted - I really feel like I appreciate the support and it's amazing to have access to this coming from a smaller country.' Olympic Solidarity provides assistance to all National Olympic Committees (NOCs) for athlete development programmes, as well as training for coaches and sports administrators. Priority is given to the NOCs with the greatest need to ensure that talented athletes from all backgrounds have an equal opportunity to compete, enhancing the universality of the Olympic Games. Many of these athletes beneﬁt from individual scholarships, which include ﬁnancial assistance through monthly grants that help with preparation for the Games. In fact, 1,331 athletes from 159 NOCs, representing 26 sports, received Olympic Solidarity Scholarships for Paris 2024. These athletes, with Limtiaco, Hannesdóttir and Nadeem among their"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Game Changing Technology Platforms Start with Intel  Intel, together with our trusted partners, is delivering technological advancements to make the Olympic Games Paris 2024 the best ones yet. We're providing processing power and the technology that enables 5G connectivity for seamless experiences, 3D simulation to foster sustainability, and advanced artiﬁcial intelligence for a reimagined Olympic Games. Enabling game-changing technology starts with Intel."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 52-quote-1\" style=\"top:709px; left:477px;\" src=\"/122/static/_content/52-quote-1.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg52Anim = new TimelineMax();\n          pg52Anim.fromTo(cOf(\"52-quote-1\"), 0.8, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg52Anim.stop();\n        }\n      ",
    "searchText": "52  Feature: Olympic Solidarity scholarships  number, now have the chance to inspire future generations of athletes from their respective countries while competing at the Games. 'I want to be able to go there and put up a time where people will be able to recognise that athletes from Micronesia can compete with the best,' Limtiaco says. 'That's my main goal. It will help people recognise that even if you come from a small island, you're able to do these great things. That will open up the road for future generations. 'I think there's so much untapped potential back home - the kids just don't have the resources, the coaching or the guidance that other countries have. 'I've been really blessed so far with all the opportunities that I've been given, and I want to be able to give back to the kids, so they can also reach their full potential and hopefully get the experiences that I've been fortunate enough to have or be given.' Nadeem feels that he has already inspired athletes from Pakistan with his achievement at the World Athletics Championships but wants to ensure he builds a permanent legacy in his country.  1 Nadeem ﬁnished ﬁfth in javelin at Tokyo 2020, before winning silver at the World Championships in 2023. 2 Tasi Limtiaco competed in the 200m individual medley at Tokyo 2020.  1  2  'I'd like to develop a structure - along with the athletics federation and my coach,' he says. 'Together we want to build a good network of athletics and from which athletes can beneﬁt from a good culture.' For Hannesdóttir, competing at Paris 2024 will not only be a chance to inspire the next generation, but to be part of a momentous landmark in Olympic history. The Games  will be the ﬁrst to achieve full gender parity on the ﬁeld of play. 'The sport of triathlon is probably one of the most gender equal sports,' Hannesdóttir says. 'We have equal prize money; we race across the same distances. 'I have always felt really supported as a woman in the triathlon community. I would love that for every single woman competing, no matter what sport that is, so for the Olympics to reach a milestone like that is for the history books and is really special. 'We have so many female athletes all around the world from so many countries that are so inspiring and strong. They deserve to have the same opportunities as male athletes, so I think it's amazing. I feel really connected to that milestone.' ■  ' I want to be able to give back to the kids, so they can also reach their full potential and hopefully get the experiences that I've been fortunate enough to have' Tasi Limtiaco"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 54-title-1\" style=\"top:137px; left:35px;\" src=\"/122/static/_content/54-title-1.png\" />\n        <img class=\"halfScale 54-sub-1\" style=\"top:471px; left:54px;\" src=\"/122/static/_content/54-sub-1.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg54Anim = new TimelineMax();\n          pg54Anim.fromTo(cOf(\"54-title-1\"), 0.8, {opacity:0}, {opacity:1, ease: Power2.easeOut}, 1);\n          pg54Anim.fromTo(cOf(\"54-sub-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1.4);\n        }\n\n        function onPageLeave() {\n          pg54Anim.stop();\n        }\n      ",
    "searchText": "THROUGH OLYMPIC REVIEW CREATES A VISITORS' GUIDE TO THE SPECTACULAR LOCATIONS AND ICONIC LANDMARKS THAT WILL HOST THE WORLD'S BEST ATHLETES DURING THE OLYMPIC GAMES PARIS 2024"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Teahupo'o, Tahiti France's diverse heritage will be on display during the Paris 2024 surﬁng competition, which will take place in a simply breathtaking location. Teahupo'o may be a quaint ﬁshing village on the French Polynesian island of Tahiti, but it boasts one of the most powerful waves in the world. Already a highly anticipated stop on the World Surf League calendar, Teahupo'o will now welcome surfers vying for an Olympic gold medal."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "The Grand Palais The Grand Palais will host fencing and taekwondo during Paris 2024 after undergoing a full restoration over the past year. The exhibition hall and museum complex were considered the height of innovation when ﬁrst built for the 1900 Universal Exposition, particularly because of the spectacular glass roof. The iconic venue has previously been used for sporting events such as the World Fencing Championships in 2010."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Pont Alexandre III The Pont Alexandre III runs between two banks of the Seine River - at one end is the Grand Palais and at the other is Les Invalides. The bridge will not just connect these two Olympic venues but will also be the ﬁnish line for the cycling time trials, swimming marathon, triathlon and Para triathlon. The elaborate bridge, ﬂanked by four gilt bronze sculptures, each accompanied by a winged horse, was constructed towards the end of the 19th century."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Château de Versailles The Château de Versailles, an extravagant palace on the outskirts of Paris, was ﬁrst built in the 17th century as  a residence for King Louis XIV. It became the centre of royalty until the French Revolution, after which it was turned into a public museum. The equestrian and modern pentathlon competitions will  take place in the immaculate gardens surrounding the Château de Versailles, while the Olympic marathon runners will race out to the palace before they head back to the city centre."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Power matters  Intense preparation, hours of testing, team spirit, precision. Every detail matters. We are proud to celebrate 20 years as Wordwide IT Partner of the Olympic and Paralympic Games.  Advancing what matters"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Marseille Marina Marseille Marina will be transformed into a world-class sailing venue  for Paris 2024. The location on the Mediterranean, which lies 660 kilometres from the French capital, offers exceptional sailing conditions. Spectators will  be able to watch the action unfold from La Corniche, the seaside promenade that winds down along the coast, as well as on the golden sands of the Plages du Prado."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "© 2012 - Comité International Olympique (CIO) - EVANS, Jason  WINNING IS FOR ONE FIRSTS ARE FOR EVERYONE Track humanity's progress from the world's greatest stage  THE FIRST EFFECT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Les Invalides A sprawling complex of buildings constructed during the reign of King Louis XIV, Les Invalides now contains a military history museum and Napoleon Bonaparte's tomb. Situated in front of the complex, the Esplanade des Invalides will host archery and para-archery events, and will be the start point for the cycling time trial and ﬁnish line for the marathon.  Place de la Concorde Place de la Concorde, situated at the end of the Champs-Élysées in the heart of Paris, will be the unique backdrop for a number of dynamic and exciting urban sports during the  Olympic Games. The square will be transformed into the Concorde Urban Park, welcoming thousands of visitors each day for basketball 3×3, breaking, BMX freestyle and skateboarding, as well as sports demonstrations, taster sessions and DJ appearances."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Eiffel Tower The most recognisable French landmark of all has been part of the capital's skyline for 135 years, ever since it was unveiled as the centrepiece of the 1889 Universal Exposition. The 330-metre-tall tower rises above the resplendent  lawns of the Champ de Mars, where a temporary outdoor arena will be built for the beach volleyball and blind football competitions during the Olympic and Paralympic Games. Cyclists who have just completed the road race will also get an unparalleled view of the Eiffel Tower from the ﬁnish line at Trocadéro."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 68-title-1\" style=\"top:376px; left:62px;\" src=\"/122/static/_content/68-title-1.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg68Anim = new TimelineMax();\n          pg68Anim.fromTo(cOf(\"68-title-1\"), 0.8, {opacity:0, y:-40}, {opacity:1, y:0, ease: Power2.easeOut}, 1.0);\n        }\n\n        function onPageLeave() {\n          pg68Anim.stop();\n        }\n      ",
    "searchText": "ONES TO"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 69-title-1\" style=\"top:368px; left:64px;\" src=\"/122/static/_content/69-title-1.png\" />\n        <img class=\"halfScale 69-sub-1\" style=\"top:661px; left:512px;\" src=\"/122/static/_content/69-sub-1.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg69Anim = new TimelineMax();\n          pg69Anim.fromTo(cOf(\"69-title-1\"), 0.8, {opacity:0, y:-40}, {opacity:1, y:0, ease: Power2.easeOut}, 1.0);\n          pg69Anim.fromTo(cOf(\"69-sub-1\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0, ease: Power2.easeOut}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg69Anim.stop();\n        }\n      ",
    "searchText": "Clockwise from far left: Charline Picon; Kirani James; Rikako Ikee; Antoine Dupont; Noah Lyles; Valarie Allman; Nikola Karabatic; Teddy Riner; Simone Biles; Mélina Robert-Michon.  WATCH THREE EXPERIENCED JOURNALISTS FROM AROUND THE WORLD SHARE THEIR VIEWS ON THE ATHLETES THEY ARE LOOKING FORWARD TO SEEING AT PARIS 2024"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 70-title-1\" style=\"top:50px; left:40px;\" src=\"/122/static/_content/70-title-1.png\" />\n        <img class=\"halfScale 70-sub-1\" style=\"top:399px; left:43px;\" src=\"/122/static/_content/70-sub-1.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg70Anim = new TimelineMax();\n          pg70Anim.fromTo(cOf(\"70-title-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n          pg70Anim.fromTo(cOf(\"70-sub-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg70Anim.stop();\n        }\n      ",
    "searchText": "PARIS AW AI  C N E H R TOU F E H C T H S T  A WHOLE CENTURY OF WATER WILL HAVE FLOWED UNDER THE BRIDGES OF THE SEINE BY THE TIME THE WORLD'S ATHLETES ONCE AGAIN STEP ONTO THE OLYMPIC STAGE IN PARIS  2  1  By Alexandre Boyon  P  aris 2024 will be a once-in-a-lifetime moment - for a country with such strong links to the Olympic Movement, and for a whole generation of French athletes. As was the case in 1900 and 1924, the 2024 edition is set to be a milestone in Olympic history, as the ﬁrst gender parity Games. Competing on home soil, Team France will be especially determined to shine. Traditionally, countries often have their best Games when they are hosting the event, and this edition should be no different. In the 'City of Light', a number of French athletes are expected to dazzle the world with their performances."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "\n\n        <!--Video-->\n        <img class=\"abs halfScaleC halfpulse animatedpulse pointer\" style=\"top:650px; left:163px;\" src=\"/122/static/_content/white-play.png\"  onclick=\"Publish.updateVideoURL('https://www.youtube.com/embed/WzGVCfEzP24?si=D-NbM5HAsX8pBWxE')\"/>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  Issue 122  2  On 26 July, the whole of France will watch French athletes during the Athletes' Parade at the Opening Ceremony for the Olympic Games. The last time the event was staged in France, in Albertville in 1992, Michel Platini lit the cauldron. Excitement is already growing to ﬁnd out who will light up these Games. Meanwhile, at the foot of the iconic Eiffel Tower, a date with destiny awaits another national icon. At the Champ de Mars Arena, judoka Teddy Riner will be attempting to add to his already impressive heavyweight medal collection. With a record 11 world titles to his name, the double +100kg Olympic champion (London 2012 and Rio 2016) is looking to clinch his ﬁfth individual medal at what will be his ﬁfth Games - a challenge worthy of his exceptional talent. In the Stade de France, Mélina RobertMichon will hope to achieve an incredible feat of her own. At 45, the Rio 2016 discus silver medallist will be competing in her seventh Games - and they might not be her last. Her tenacity, devotion to her sport and role model status, as an athlete, a woman and a mother, demand respect. Her presence is particularly symbolic in a city which, in 1900, was the ﬁrst to feature women's events at the Games. France harbours real aspirations of breaking into the top ﬁve nations in the medal standings, and it will once again be looking to its two handball teams to play their part.  1 Will Teddy Riner be able to add a ﬁfth Olympic medal to his collection? 2 Mélina Robert-Michon will compete in her seventh edition of the Games.  The women's team are the reigning Olympic and world champions, while the men have won three golds and a silver at the past four editions of the Games. In what will be his ﬁnal competitive appearance, handball legend Nikola Karabatic will hope to write his name even further into the history books. At 40, the most decorated men's Olympic champion in a team sport wants to go out with a bang with a fourth Olympic title. In the history of team sports, only six female American basketball players have achieved more, including Sue Bird and Diana Taurasi, the only two athletes to have won ﬁve team golds. The other ball sports are not to be outdone, however. Rugby's Antoine Dupont, named the best player in the world in 2021, chose to take a break from the 15-a-side game to compete in the rugby sevens Olympic tournament this summer. Volleyball star Earvin Ngapeth, considered the Zinédine Zidane of his sport, will be leading France's efforts to defend their title from Tokyo 2020, while 7 foot 3.5 inch basketball sensation Victor Wembanyama will be aiming to scale new heights with a French team which, in Japan, lost out to the USA by only ﬁve points. The wave of Olympic optimism is sweeping not only through Paris and, of course, Tahiti, with the surﬁng events, but also the French Riviera. Charline Picon, a windsurﬁng champion in Rio and a silver medallist in Tokyo, has decided, at 39, to change course. This summer, she will race in a two-person dinghy, in the 49erFxs event, hoping to hear La Marseillaise ring out in Marseille. Immersing oneself in the Games also means diving into the world of swimming, and it would be remiss not to mention Léon Marchand, the best male swimmer of the past two World Aquatics Championships. Last July, at the World Championships in Fukuoka, he won three gold medals and captured the public imagination by taking the last individual swimming world record held by the legendary Michael Phelps, in the 400m medley. Marchand, whose parents also swam at the Games, will have plenty of good advice to fall back on this summer. His coach is none other than Bob Bowman, who mentored Phelps to his 23 Olympic titles. In Paris, Marchand could compete in four individual races and maybe even win four golds. If he managed to do so, he would make an almighty  splash in Olympic history, picking up where Johnny Weissmuller left off 100 years ago. With their heart set on making the home nation proud, France's athletes will be determined not to disappoint this summer. But the real star of the Games will be France itself, in all its splendour. Never before has a country bidding to host the event focused so heavily on its landmarks, which will provide a unique backdrop to the Olympic ﬁeld of play for athletes and the public: from the Champs-Élysées, the Palace of Versailles and Teahupo'o wave to Les Invalides, the Eiffel Tower and the Sorbonne, where Baron Pierre de Coubertin proposed reviving the Olympic Games on 23 June 1894. The whole of France will be living and breathing every moment of the event, continuing its longstanding love affair with the Olympic Games in the 'City of Love'.  Alexandre Boyon has worked for France Télévisions since 1992 and covered every summer and winter edition of the Olympic Games since Atlanta 1996. A major ﬁgure in French sports broadcasting, he commentates on Olympic swimming, athletics and other events and has been the voice of the Opening and Closing Ceremonies since Sydney 2000."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 72-title-1\" style=\"top:66px; left:38px;\" src=\"/122/static/_content/72-title-1.png\" />\n        <img class=\"halfScale 72-sub-1\" style=\"top:662px; left:43px;\" src=\"/122/static/_content/72-sub-1.png\" />\n\n        <!--VIDEO-->\n        <img class=\"abs halfScaleC halfpulse animatedpulse pointer\" style=\"top:766px; left:18px;\" src=\"/122/static/_content/white-play.png\"  onclick=\"Publish.updateVideoURL('https://www.youtube.com/embed/RNe_KL7faas?si=SCFhp3dJUU-yuLNp')\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg72Anim = new TimelineMax();\n          pg72Anim.fromTo(cOf(\"72-title-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n          pg72Anim.fromTo(cOf(\"72-sub-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg72Anim.stop();\n        }\n      ",
    "searchText": "S  he may not be a medal contender but her individual 100m butterﬂy race in the Paris La Défense Arena swimming pool will attract eyes and thoughts in Japan. She is Rikako Ikee, a 23-year-old who came back from leukaemia four years ago. Her story of human struggle is also connected to how Japan, previous host of the Olympic Games, will watch the Olympic and Paralympic Games Paris 2024. 'I was surprised that I had no tears,' she said after her national championship qualiﬁer in March, where she secured her berth for Paris after beating another  competitor by 0.01 seconds. 'Perhaps my sense of accomplishment was that high. My goal is to better the time record I set at the Rio de Janeiro Games as a 16-year-old. You are the only one who can beat yourself, so I will continue believing in myself.' Ikee was one of the rare, gifted youths who was expected to rise to swimming stardom. After her ﬁfth-place ﬁnish at Rio 2016, she became the ﬁrst Japanese swimmer to win six gold medals and the MVP award at the 2018 Asian Games. The following year, during a swimming camp in Australia, she fell ill. It was cancer.  By Wakako Yuki  SYMBO LO F THE REMARKABLE STORY OF RIKAKO IKEE OFFERS INSPIRATION TO ALL THE ATHLETES WHO WILL COMPETE AT THE OLYMPIC GAMES PARIS 2024  E P O H"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  73  Issue 122  1 Rikako Ikee has fought back from cancer to compete on the world stage again. 2 Holding a lantern with the Olympic ﬂame for the Tokyo 2020 one-year-to-go milestone.  1  She recalled that her 10-month hospitalisation made her realise how precious and dear it was to be able to swim. She kept her hope for a comeback, but the reality was that she lost so much strength and weight that she struggled to do basic push-ups. During this time, some saw that her fate and subsequent struggles bore signiﬁcant parallels to that of the Covid-19-hit Tokyo Games. After her hospital discharge in 2020, she was asked to take part in the one-year-to-go video message '2020 plus 1' for the postponed Games.  2  Standing in the empty Olympic Stadium, holding up a lantern with the Olympic ﬂame, Ikee extended a message of sympathy towards athletes around the world who faced unprecedented ordeals due to the pandemic, comparing it to her own experience. 'Once lost, we realise how precious and dear those simple things [are that] we took for granted - for athletes, how we loved our sports,' she said. The video depicted the Olympic ﬂame as the symbol of hope. Holding it in the dark stadium, the slender ﬁgure of Ikee was etched in our minds. It is true that many Japanese look back to the Tokyo Games with complex, bittersweet feelings. For one thing, they were the Games so unlike what we had expected. No spectators, foreign nor domestic, therefore no real magical moments left for the next generations. Many had little opportunity to experience what the Games mean to our lives. Hence the feelgood factor did not last, nor the sense of ownership of the Games, which usually forms the basis for the Games legacy. In hindsight it can also explain why it was easier for people to feel disappointed when faced with the post-Games corruption scandal. You cannot defend what you did not experience. However, we also were keenly aware of one thing: that the Tokyo Games brought us to tears, made us realise we can believe in humanity. I have covered the Games for nearly 30 years but have never heard so many  athletes expressing gratitude or praising their rivals regardless of winning or losing. It was obviously because they all knew the courage and resilience each had to muster to come here, knowing how difficult it was to believe in something and carry on, and how it felt just being here and competing against each other. Watching them, it was as if being reminded that human nature has an undeniable goodness. The ordeal that divided us could also unite us in such kindness. Ikee, who participated in the swimming relays at the Tokyo Games, was once reﬂecting on herself. She said she was trying to focus on her progress after the illness, not comparing it to her previous achievements. If you compare it to your past, you feel negative and sad. But if you focus on current progress, every day is a personal best. Her philosophy can also be useful when we look back to the Tokyo Games. Instead of comparing it to what it ought to have been, we could focus on what we gained. In the face of the pandemic, we were able to prepare a stage for the world's athletes, and they in turn gave us important insights into ourselves. Imagine how many people in the world watched their own athletes and felt the same. Tony Estanguet, President of the Paris 2024 Organising Committee, once compared Games organisation to a relay, receiving a baton from the previous host. In a post-Tokyo Games interview he observed that Tokyo 2020 gave Paris a precious baton, which was a hope that sport can revive even in the darkest time and let people share emotions. Paris shall be the rallying point of the world as a post-Covid celebration. In its unique way, the Games will attempt to turn a page in history, from public engagement to creating lasting social legacy. We as the previous host would cheer for the world athletes from our heart, and for Ikee, whose journey in Paris embodies the conclusion of an Olympic story we have followed.  A senior writer for The Yomiuri Shimbun, Wakako Yuki has followed the Olympic Movement for the past 30 years, covering 15 Olympic Games and 10 Paralympic Games. She is a Sports Council member of the Japan Sports Agency and Vice-President of the Japan Olympic Academy."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- ANIMATION -->\n        <img class=\"halfScale 74-title-1\" style=\"top:45px; left:39px;\" src=\"/122/static/_content/74-title-1.png\" />\n        <img class=\"halfScale 74-sub-1\" style=\"top:274px; left:108px;\" src=\"/122/static/_content/74-sub-1.png\" />\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg74Anim = new TimelineMax();\n          pg74Anim.fromTo(cOf(\"74-title-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1);\n          pg74Anim.fromTo(cOf(\"74-sub-1\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1.1);\n        }\n\n        function onPageLeave() {\n          pg74Anim.stop();\n        }\n      ",
    "searchText": "FROM MO N  A R P I S O T L A E TR  THE MEMORIES FROM MONTREAL 1976 LIVE LONG IN KAREN ROSEN'S MIND, AND SHE IS ANTICIPATING MORE SPECTACULAR PERFORMANCES FROM TODAY'S STARS ON THE GREATEST STAGE OF ALL  1  By Karen Rosen"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "\n\n        <!--VIDEO-->\n        <img class=\"abs halfScaleC halfpulse animatedpulse pointer\" style=\"top:208px; left:468px;\" src=\"/122/static/_content/white-play.png\"  onclick=\"Publish.updateVideoURL('https://www.youtube.com/embed/RW94mABPEpw?si=YXPnQtsSNqUB2l1L')\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "75  2  A  t my ﬁrst Olympic Games in 1976, I was the same age as Nadia Comaneci. But while Nadia was scoring perfect 10s in gymnastics, I was on a family vacation in Montreal, Canada. My father, Mel Rosen, was the athletics coach at Auburn University in Alabama, USA. He believed the Olympics would never again be so close to our hometown, so we got tickets for every track and ﬁeld session. It was an unexpected bonus when Dad's freshman sprinter, Harvey Glance, won the 100m at the US Olympic Trials. We were in the stadium cheering as Harvey won a gold medal in the 4 × 100m relay. Sadly, Harvey passed away last year. But his legacy lives on in the athlete he coached, Kirani James of Grenada. Kirani is the only athlete who has won gold (2012), silver (2016) and bronze (2020) medals in the 400m at the Olympics and I can't wait to see what he does in Paris. Kirani was only 19 - the same age as Harvey in Montreal - when he competed in London. He predicted that Grenada, which then had a population of about 116,000, would be 'going crazy' after he won his country's ﬁrst Olympic medal - and a gold to boot. A street in the capital city and an athletics stadium were named after him. Consistency is a hallmark of Kirani's career. He has also captured gold, silver and bronze medals at the World Athletics Championships, most recently in 2022. But triumph has mixed  with tribulation over the past seven years. In 2017, Kirani didn't feel like himself and was diagnosed with Graves' disease. He'll be on medication the rest of his life. In 2019, he lost his mother after a lengthy illness. And then during a training session last June, he discovered Harvey unresponsive following a heart attack. Kirani's brother thought he might retire with his coach/father ﬁgure gone. Instead, he went to the 2023 World Championships in Budapest and won the Diamond League ﬁnal. Even though Kirani is now 31, no one counts him out. Another athlete I look forward to watching in Paris also has a tie to my father. Before Dad was the USA's head men's coach at Barcelona 1992, his Auburn team included Lance Brauman. Now a coach himself, Lance has helped develop Noah Lyles into one of the fastest men in the world. Noah won three gold medals at the 2023 World Championships and will tell anyone within earshot that he wants four in Paris (adding a leg on the 4 × 400m relay to his usual 100m, 200m and 4 × 100m relay). Noah is a showman, raising the proﬁle of his sport through effort, exuberance and exposure on social media. He introduced 'fashion walks' to meets and is an artist and rapper whose love of anime shows in his hair or ﬁngernail colours. Noah has also shared his mental health struggles to help other young people. In Tokyo, he was crestfallen after winning only a bronze medal in the 200m. He said he missed the energy of the crowd as spectators were forbidden due to the Covid-19 pandemic. With a full stadium in Paris, Noah hopes to deliver the ﬁrst gold medal in the men's 100m and/or the men's 200m for the USA since 2004. I'm also eager to see if Valarie Allman can become the ﬁrst US woman to win back-toback Olympic titles in the discus. Valarie was a competitive dancer who joined the track team so she could get a free spaghetti dinner at her high school. Now 29, Valarie brings elegance and ebullience to the event. She said she was teased when she started throwing because what she was doing was considered very masculine. Now she gets only respect. Valarie says: 'There are a lot  1 Noah Lyles will be targeting four gold medals in Paris. 2 Simone Biles is set to add another remarkable chapter to her Olympic career.  of different body styles and technical models that can yield really great results,' and she proves that with every spin. And while I never saw Nadia compete in person, I have seen the greatest gymnast of all time perform at two Olympics - and hope to witness a third. Of course, that's Simone Biles. It's ﬁtting that the scoring maximum is no longer the '10' because Simone does moves that are off the charts. She won four gold medals and a bronze at Rio 2016 and seemed poised to add to her gold-medal haul at Tokyo 2020. I remember seeing Simone walk off the ﬂoor during the team ﬁnal and wondered what was happening. It turns out she had 'the twisties', a sudden inability to do spins. Simone withdrew from most of her events, then came back to win the bronze medal on the balance beam - a tribute to her perseverance and mental fortitude. Since then, Simone has helped drive conversations about mental health in sports. In 2023, she got married and launched a comeback. At age 27, Simone's still hitting routines that were unfathomable at my ﬁrst Olympics in 1976.  Karen Rosen will cover her 19th Olympic Games at Paris 2024. She has written about Olympic sports for outlets including The Atlanta Journal-Constitution - when the Games were practically in her backyard! - TV Guide magazine, World Athletics, NBCOlympics.com and the U.S. Olympic & Paralympic Committee."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 76-title\" style=\"top:237px;left:23px\" src=\"/122/static/_content/76-title-1.png\"/>\n        <img class=\"halfScale 76-title\" style=\"top:288px;left:88px\" src=\"/122/static/_content/76-title-2.png\"/>\n        <img class=\"halfScale 76-title\" style=\"top:343px;left:23px\" src=\"/122/static/_content/76-title-3.png\"/>\n        <img class=\"halfScale 76-sub\" style=\"top:484px;left:44px\" src=\"/122/static/_content/76-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg76Anim = new TimelineMax();\n          pg76Anim.staggerFromTo(cOf(\"76-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 0.25, 1)\n          .fromTo(cOf(\"76-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.75)\n        }\n\n        function onPageLeave() {\n          pg76Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "THE COLOSSAL LEGACY OF A  FORGOTTEN HERO GEORGE HIRTHLER, AUTHOR AND EXECUTIVE BOARD MEMBER OF THE INTERNATIONAL PIERRE DE COUBERTIN COMMITTEE, CONSIDERS HOW PARIS 2024 WILL PROVIDE A STUNNING REMINDER OF THE EVER-EXPANDING INFLUENCE OF ITS ALMOST ANONYMOUS NATIVE SON  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  77  Issue 122  2  T  he brilliant innovations of Paris 2024 are destined to mark an evolutionary turning point in the history of the modern Olympic Games. Nothing quite this bold has been attempted before. The dazzling Opening Ceremony on the Seine, the milestone 50/50 achievement in gender parity, and the monumental beauty of venues and fan zones married to Paris' inimitable landmarks will stun the world and stir the souls of a global audience of more than three billion people. Ironically, the name of the man who started it all, Pierre de Coubertin - who launched the Games in Paris on June 23, 1894, at the age of 31 - will be largely absent from the festival, as it traditionally has been. Although his name will be evoked by IOC President Thomas Bach, and mentioned by a few dignitaries and journalists, the public will be largely unaware that the world's most important  1 Pierre de Coubertin, pictured in Barcelona in 1925, founded the modern Olympic Games in 1894. 2 Today, the Olympic Games attract a global audience of more than three billion.  celebration of humanity owes its origins - and its global success - to the singular work of a bygone visionary. And yet, as Paris will clearly demonstrate, his ideas and his hopes for uniting the world in friendship and peace through sport are becoming ever more relevant and urgent in our divided world. The gulf between his legacy and his anonymity is as wide as the oceans and continents he crossed to put the Olympic Movement on the map. Today, outside a small circle of historians and Olympic admirers, Coubertin's name, let alone his story, is all but forgotten. In fact, if you Google the 10 most inﬂuential people of the 19th century, you'll get an impressive list of names that includes Abraham Lincoln, Charles Darwin, Alexander Graham Bell, Thomas Edison, Louis Pasteur, Marie Curie and Napoleon, but no Coubertin. And yet, it is not difficult to argue that the relevance, global impact, symbolic power and true meaning of his legacy are more immediate than ever. His name belongs on that list. Consider the colossus he created. At this moment, as we go to press, more than 200 National Olympic Committees  are preparing to celebrate the departure of their teams for Paris. Approximately 14,250 athletes, coaches and officials will arrive in the 'City of Light' and settle into the Olympic Village for a fortnight of glorious competition. Thirty-two International Federations will organise 329 events, which will be broadcast and absorbed by billions through every form of modern media. On the ground in Paris, a staff of 4,000, supported by 45,000 volunteers and 16,000 contractors, will ensure that myriad operational logistics of the Games ﬂow like the Seine. More than eight million tickets have already been sold and some two million Olympic fans will soon descend on the city. Aside from the 20,000 journalists and media representatives covering the Games, those observing the events most closely will be contingents from Los Angeles 2028 and Brisbane 2032 - the next hosts of the Olympic Games - and their winter counterparts from Milano Cortina 2026, plus prospective hosts, the French Alps 2030, and Salt Lake City 2034. The future reach of Coubertin's legacy is a reality right now."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 78-quote\" style=\"top:100px;left:477px\" src=\"/122/static/_content/78-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg78Anim = new TimelineMax();\n          pg78Anim.fromTo(cOf(\"78-quote\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg78Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "78  Feature: Pierre de Coubertin  The public will be largely unaware that the world's most important celebration of humanity owes its origins to the work of a bygone visionary  1  More importantly, the currency and adaptability of his ideas ensure that every edition of the Olympic Games reﬂects in some ways the evolution of society and the most pressing issues of the times. That has never been more true than it is today in Coubertin's hometown of Paris. The 5,250 female Olympians expected to take to the ﬁeld, achieving full parity with their 5,250 male counterparts for the ﬁrst time - symbolise the success of a century-long struggle for women's rights in every ﬁeld of endeavour. The Refugee Olympic Team - 36 athletes driven from their homes by crises both natural and human-made, who nonetheless rose to the heights of Olympic qualiﬁcation - throws a spotlight on the inequities suffered by millions of dispossessed people around the world. And with war raging, as the Russian invasion of Ukraine continues into a third year amongst other armed conﬂicts, the Olympic Movement's ﬁght for peace is more important than ever.  1 Coubertin (far left) with Edward Prince of Wales (second from left) at Paris 1924. 2 The Parade of Athletes at the Paris 1924 Opening Ceremony.  Coubertin's Games are not only the world's greatest celebration of humanity, exhibiting the unity of the world as nothing else can; they are also a prism for every issue that divides us and threatens that unity, every issue at the forefront of global debate. Social progress, cultural conﬂict and political differences all animate the Games and turn them into a worldwide centre of discourse, giving the Games the kind of relevance Coubertin always hoped they would have. Paris 2024 will once again make it clear that Coubertin created the most successful international movement of our times. Despite its ﬂaws and the criticism directed at it, the Olympic Movement is an irreplaceable phenomenon of immense value to our world. It has become a USD 7 billion quadrennial enterprise, engaging media empires and corporate partners both worldwide and within the borders of host countries. Of course, the Olympic Movement has grown and expanded in ways that Coubertin could not have anticipated - and yet it has retained at its soul the values of friendship, excellence and respect that he instilled at the heart of Olympism, and it has clung to the essential mission  he set forth on: to unite the world in friendship and peace through sport. All of which begs the question: why don't we know him? How is it possible that the man who sacriﬁced everything he had to make the Olympic Movement a permanent part of world culture has been so thoroughly forgotten? Part of the answer, of course, is timing. Although he had risen to international prominence as he presided over his last Olympic Games, at Paris 1924, he gradually fell into obscurity after he retired. He had exhausted his family fortune putting the Games on the map and, by the time he died, on a lone walk in a park in Geneva on 2 September 1937, he was all but forgotten beyond the Olympic halls of Lausanne. While a few obituaries and ceremonies celebrated his legacy, the rising conﬂicts in Europe and the onslaught of World War II buried almost all public memory of the man. Attempts to resurrect his story in France have met with criticisms by a number of historians and journalists who take issue with his early opposition to women competing in the Games and his refusal to denounce the Nazi hosts of the Olympic Games Berlin 1936. Even though multiple defenders argued his case, Coubertin has basically remained forgotten. Despite his anonymity, there is little question that Pierre de Coubertin's genius will be on display once again in his hometown this summer. As Paris vaults the Games to new levels of brilliance, some will wonder how long it will be before the weight of Coubertin's legacy inevitably draws a bright spotlight to the story of how he built this grand and still-growing contribution to modern life. ■ George Hirthler is an American writer. He is the author of the historical ﬁction The Idealist, a novel about the life and times of Baron Pierre de Coubertin. He was awarded the Pierre de Coubertin Medal in 2022."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 79-title\" style=\"top:123px;left:62px\" src=\"/122/static/_content/79-title-1.png\"/>\n        <img class=\"halfScale 79-title\" style=\"top:173px;left:62px\" src=\"/122/static/_content/79-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg79Anim = new TimelineMax();\n          pg79Anim.staggerFromTo(cOf(\"79-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut, onComplete: addContentLinks}, 0.25, 1)\n        }\n\n        function onPageLeave() {\n          pg79Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Review  79  Issue 122  PARTICIPATION OF WOMEN AT THE OLYMPIC GAMES With full gender parity expected on the ﬁeld of play at Paris 2024, George Hirthler addresses Pierre de Coubertin's attitude towards women's participation in sport Although Pierre de Coubertin was a visionary, he was born and raised in 19th century France and carried the dominant attitudes of his culture towards women forward as he launched the Olympic Movement. In the broadest sense, Coubertin wanted everyone to engage in sport. 'Sport is', he wrote, 'the birthright of all, equally and to the same degree, and nothing can replace it.' But given the paternalistic mores of the ﬁn de siècle, protecting the dignity of women was a high priority for him - and therein lies the basis of his opposition to women competing at the Olympic Games. 'If some women want to play football or box, let them, provided that the event takes place without spectators, because the spectators who ﬂock to such competitions are not there to watch a sport,' he said. In essence, he wanted to protect women from those whose motives were more lecherous than athletic. Despite his adversarial position, he never stood directly in the way of women competing at the Games and, in fact, left the decisions up to the Organising Committee in every host city. Under his IOC presidency, from Paris 1900 to Paris 1924, the participation of women in the Games grew six-fold, from 22 to 135. Over the course of his presidency, women competed in golf, archery, equestrian, tennis, diving, sailing, fencing, swimming and ﬁgure skating events. Beyond the Olympic arena, he held a more progressive view of women's rights. As an educational reformer, Coubertin aligned with Jules Ferry and Jules Simon, both advocates for women's education. Although he believed that the highest calling of a woman was to be 'the companion of man, the future mother of a family', he recognised - as few of his time did - that education and the law were key to empowering women's independence if they chose to divorce or  stay single. He said: 'Let the laws protect her, put her in a position to resist, and even to escape from marital tyranny, nothing more legitimate' and ensure 'to those who do not marry, ways to earn an honest living.' Although the roles of women were beginning to evolve at the beginning of the 20th century, leading countries such as France, England and the United States all operated on a double standard of 'separate spheres' in gender equality. It is interesting to note that not long after Coubertin helped launch the boy scouts of France in 1911, he turned his support to the ﬂedging dreams of Renée de Montmort, a young family friend from Normandy, and helped her form the girl scouts of France (Éclaireuses de France), a movement 'with a view to contributing to their physical development, consolidating their moral and intellectual education, preparing them for practical life'. In essence, he helped create a female scouting movement parallel to the one for boys.  2  While Coubertin was a traditionalist in many ways, it is unfair to call him a misogynist because he did advocate for the advancement of women in other ways beyond the Olympic stadium. For the most part, this is adapted from The Feminist Controversy: Coubertin's Opposition to Women Competing in the Olympic Games, by Natalia Camps Y Wilant and George Hirthler, which appears as article 3.16 in Pierre de Coubertin - Life, vision, inﬂuences and achievements of the founder of the modern Olympic Games, a publication of the Olympic Studies Centre: www.olympics.com/ioc/ olympic-studies-centre The story of the founding of the Girl Scouts of France is taken from Pierre de Coubertin, l'épopée Olympique, by Marie-Thérèse Eyquem (Paris: Calmann-Lévy, 1966), pp 231-232."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 80-title\" style=\"top:83px;left:43px\" src=\"/122/static/_content/80-title-1.png\"/>\n        <img class=\"halfScale 80-sub\" style=\"top:148px;left:43px\" src=\"/122/static/_content/80-sub-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:822px;left:195px;height:14px;width:131px;\">\n          <a href=\"mailto:studies.centre@olympic.org\"></a>\n        </div>\n\n        <div class=\"addContentLinkThree\" style=\"top:822px;left:343px;height:14px;width:194px;\">\n          <a href=\"https://olympics.com/ioc/olympic-studies-centre\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLinkThree\" style=\"top:836px;left:252px;height:14px;width:110px;\">\n          <a href=\"https://www.facebook.com/OlympicStudiesCentre/\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLinkThree\" style=\"top:836px;left:376px;height:14px;width:100px;\">\n          <a href=\"https://library.olympics.com\" target=\"_blank\"></a>\n        </div>\n\n        <!--LINKY-->\n        <!--One-->\n        <div class=\"addContentLinkThree\" style=\"top:370px; left:41px; width:150px; height:20px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3155234/handbook-of-sport-and-international-development-ed-by-nico-schulenkorf-et-al\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLinkThree\" style=\"top:386px; left:41px; width:178px; height:20px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3155234/handbook-of-sport-and-international-development-ed-by-nico-schulenkorf-et-al\" target=\"_blank\"></a>\n        </div>\n        <!--Two-->\n        <div class=\"addContentLinkThree\" style=\"top:369px; left:256px; width:132px; height:20px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3154842/pierre-de-coubertin-life-vision-influences-and-achievements-of-the-founder-of-the-modern-olympic-gam\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLinkThree\" style=\"top:387px; left:256px; width:190px; height:20px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3154842/pierre-de-coubertin-life-vision-influences-and-achievements-of-the-founder-of-the-modern-olympic-gam\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLinkThree\" style=\"top:401px; left:256px; width:204px; height:20px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3154842/pierre-de-coubertin-life-vision-influences-and-achievements-of-the-founder-of-the-modern-olympic-gam\" target=\"_blank\"></a>\n        </div>\n        <!--Three-->\n        <div class=\"addContentLinkThree\" style=\"top:369px; left:473px; width:207px; height:20px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3155477/discovering-pierre-de-coubertin-an-educational-programme-based-on-the-words-of-pierre-de-coubertin-t\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLinkThree\" style=\"top:387px; left:473px; width:158px; height:20px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3155477/discovering-pierre-de-coubertin-an-educational-programme-based-on-the-words-of-pierre-de-coubertin-t\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLinkThree\" style=\"top:401px; left:473px; width:165px; height:20px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3155477/discovering-pierre-de-coubertin-an-educational-programme-based-on-the-words-of-pierre-de-coubertin-t\" target=\"_blank\"></a>\n        </div>\n\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg80Anim = new TimelineMax();\n          pg80Anim.fromTo(cOf(\"80-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"80-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut, onComplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg80Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "80  Olympic Studies  OLYMPiC STUDiES The latest book reviews from the IOC Olympic Studies Centre - your source of Olympic knowledge  HANDBOOK OF SPORT AND INTERNATIONAL DEVELOPMENT This handbook offers a comprehensive and innovative view of sport and international development. With contributions from world-renowned academic experts in the ﬁeld, it explores the role that different sports initiatives - from community-based projects to large-scale events - can play in a wide variety of contexts. This book highlights numerous examples of successful practice on key sport-fordevelopment themes such as gender, education, livelihoods, disability, healthy lifestyles, social inclusion, peace and reconciliation. It also offers some timely and insightful contributions on the achievements, opportunities, challenges and current debates in the ﬁeld, including emerging themes such as action sports, climate change and athlete diplomacy.  EDiTORS: Nico Schulenkorf, Jon Welty Peachey, Ramón Spaaij, Holly Collison-Randall. PUBLiSHED BY: Edward Elgar Publishing, 2023, ISBN 9781800378919, 472 pages, in English.  PIERRE DE COUBERTIN:  DISCOVERING PIERRE DE COUBERTIN:  In collaboration with the CIPC and the CFPC, the Olympic Studies Centre presents a new reference document on the life and work of Pierre de Coubertin. More than 40 authors look at various facets of the renovator of the Olympic Games. This document looks at the man himself, the educator, those who shaped his thinking, his action as IOC President, his ﬁght to promote physical education, his political orientations and his aspirations for the Olympic Movement. This is a must-have document for anyone wishing to understand the personality, thinking and work of a man who was in many ways a visionary, but who was also strongly inﬂuenced by the political and cultural context of his time.  Discovering Pierre de Coubertin is a new educational resource for teachers, pupils and students. It helps teachers to organise and run lessons on the various themes addressed by Pierre de Coubertin, the founder of the modern Olympic Games, throughout his life. The material is built around Coubertin's original writings on subjects such as the symbols and values of Olympism, sport for all, the contribution of sport to international understanding and peace, the spirit of chivalry and fair play, and the participation of women in the Olympic Games. The programme is supported by questions designed to stimulate reﬂection and discussion among students on how these themes were perceived in the historical and social context of the late 19th and early 20th centuries, and to extend the reﬂection to today's social context.  LIFE, VISION, INFLUENCES AND ACHIEVEMENTS OF THE FOUNDER OF THE MODERN OLYMPIC GAMES  AUTHORS: Members of the International Pierre de Coubertin Committee (CIPC), the French Pierre de Coubertin Committee (CFPC). EDiTED BY: The Olympic Studies Centre, Stephan Wassong (CIPC), Gilles Lecocq (CFPC), 2023, 133 pages, in English and French.  AN EDUCATIONAL PROGRAMME BASED ON THE WORDS OF PIERRE DE COUBERTIN  AUTHOR: The Olympic Studies Centre EDiTED BY: The Olympic Studies Centre, 2023, 40 pages, in English, French and Spanish.  FIND OUT MORE For historical, factual and academic research, library resources and book loans, visit the Olympic World Library or contact us. studies.centre@olympic.org olympics.com/ioc/olympic-studies-centre OlympicStudiesCentre library.olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 82-title\" style=\"top:103px;left:44px\" src=\"/122/static/_content/82-title-1.png\"/>\n        <img class=\"halfScale 82-title\" style=\"top:164px;left:44px\" src=\"/122/static/_content/82-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg82Anim = new TimelineMax();\n          pg82Anim.staggerFromTo(cOf(\"82-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut, onComplete: addContentLinks}, 0.25, 1)\n        }\n\n        function onPageLeave() {\n          pg82Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "82  Obituaries  OBITUARIES  We remember Olympians and ﬁ gures from the Olympic Movement who have passed away  MOUNiR SABET IOC Honorary Member and former athlete who served as President of the Egyptian Olympic Committee Mounir Sabet, from Egypt, has died at the age of 87. Passionate about sport, and in particular shooting, he earned a place in Egypt's national shooting team in 1965. He served as President and as a Board member of the Egyptian Shooting Federation, and held leadership roles within the Egyptian Olympic Committee, African Shooting Confederation and Council of the International Shooting Sport Federation.  Elected as an IOC Member in 1998, he served on several IOC commissions during his tenure before becoming an IOC Honorary Member.  LANCE LARSON Two-time Olympic swimming medallist Lance Larson, of the USA, has died aged 83. Larson became the ﬁrst man to complete the 100m butterﬂy in under one minute when he set a new world record of 59 seconds in June 1960. A month later, he lowered the mark again to 58.7 seconds and would go on to win two medals at that year's Olympic Games in Rome. Larson won gold in the 4 × 100m medley relay, swimming the butterﬂy leg to help set a new world record of 4:05.4 in the ﬁnal. He had earlier won silver in the 100m freestyle, clocking the same time as gold medallist John Devitt of Australia in a result that paved the way for the use of electronic touchpads in swimming.  EMiLiO CORREA Cuba's Olympic and world boxing champion Emilio Correa has died at the age of 71. Alongside Teóﬁlo Stevenson and Orlando Martínez, Correa made history at the Olympic Games Munich 1972, becoming one of the ﬁrst Cuban boxers to win Olympic gold. The country has since gone on to win 41 gold medals in the sport, and 78 medals overall, second only to the USA.  SHAWN BARBER Former pole vault world champion Shawn Barber, of Canada, has passed away, aged 29. As well as winning the 2015 world title, Barber competed in the Olympic Games Rio 2016, ﬁnishing 10th in the ﬁnal, and was the 2015 Pan Am Games gold medallist and a two-time medallist at the Commonwealth Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  83  Issue 122  ÂNGELO ViCTORiANO Former Angola international basketball player Ângelo Victoriano has passed away at the age of 56. Throughout his playing career, Victoriano represented his country at three editions of the FIBA Basketball Cup (1990, 1994 and 2002) and featured at the Olympic Games four times (1992, 1996, 2000 and 2004). The record eight-time FIBA AfroBasket winner was inducted into the FIBA Hall of Fame in 2023.  OLGA FiKOTOVA-CONNOLLY Last living female Olympic athletics gold medallist from Melbourne 1956 Olga Fikotova-Connolly, discus gold medallist at the Olympic Games Melbourne 1956, has passed away at the age of 91. The Czech thrower triumphed in a memorable contest in Melbourne, which saw the Olympic record broken four times. It was at these Games that she met the USA's Hal Connolly, who won gold in the hammer the day after her victory. The pair eventually married in  Prague's Old Town Square in front of 30,000 people, with fellow Olympic champions Emil Zatopek and Dana Zatpkova as their witnesses. Fikotova-Connolly then moved to the USA and competed in four more editions of the Olympic Games for her adopted country. She was also a talented basketball player and won a 1954 European Championships silver medal with Czechoslovakia.  LEVAN TEDiASHViLi Two-time Olympic wrestling champion Levan Tediashvili has passed away, aged 75. Representing the Soviet Union, Tediashvili won freestyle gold in the 82kg weight class at the Olympic Games Munich 1972, before topping the podium in the 90kg event at the Olympic Games Montreal 1976. He was also a four-time world champion in 1971, 1973, 1974 and 1975, remaining unbeaten internationally from 1971 to 1977. Tediashvili later moved into acting, playing the starring role of a former wrestling champion in the 2021 feature ﬁlm Brighton 4th, for which he was awarded Best Actor at the 2021 Tribeca Film Festival."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "\n\n        <!-- Circle1 -->\n        <div class=\"abs\" style=\"top:80px; left:412px\">\n\n          <img class=\"halfScaleC 84-image-1\" style=\"top:-97px; left:-26px;\" src=\"/122/static/_content/84-image-1.png\" />\n\n          <img class=\"halfScaleC 84-line-1-1\" style=\"top:148px; left:76px;\" src=\"/122/static/_content/84-line-1-1.png\" />\n          <img class=\"halfScaleC 84-line-1-2\" style=\"top:168px; left:142px;\" src=\"/122/static/_content/84-line-1-2.png\" />\n\n          <img class=\"halfScale 84-sub-1-1\" style=\"top:211px; left:1px;\" src=\"/122/static/_content/84-sub-1-1.png\" />\n          <img class=\"halfScale 84-sub-1-2\" style=\"top:236px; left:144px;\" src=\"/122/static/_content/84-sub-1-2.png\" />\n\n          <!--Numbers-->\n          <h1 class=\"abs paris2024B 84-no\"\n          style=\"top: 176px; left: 1px; font-size: 1.8em; font-weight:300; margin:0; color:#646fb4; padding:0; margin:0;\"\n          data-number='{\"to\": 6000, \"comma\":true}' ></h1>\n          <h1 class=\"abs paris2024B 84-no\"\n          style=\"top: 202px; left: 145px; font-size: 1.8em; font-weight:300; margin:0; color:#646fb4; padding:0; margin:0;\"\n          data-number='{\"to\": 6000, \"comma\":true}' ></h1>\n\n\n        </div>\n\n        <!-- Circle2 -->\n        <div class=\"abs\" style=\"top:250px; left:54px\">\n\n          <img class=\"halfScaleC 84-image-2\" style=\"top:-88px; left:-88px;\" src=\"/122/static/_content/84-image-2.png\" />\n\n          <img class=\"halfScale 84-title-2-1\" style=\"top:0px; left:177px;\" src=\"/122/static/_content/84-title-2-1.png\" />\n\n          <!--Line-->\n          <img class=\"halfScaleC 84-line-2-1\" style=\"top:16px; left:145px;\" src=\"/122/static/_content/84-line-2-1.png\" />\n          <img class=\"halfScaleC 84-line-2-2\" style=\"top:130px; left:169px;\" src=\"/122/static/_content/84-line-2-2.png\" />\n          <img class=\"halfScaleC 84-line-2-3\" style=\"top:157px; left:21px;\" src=\"/122/static/_content/84-line-2-3.png\" />\n          <!--sub-->\n          <img class=\"halfScale 84-sub-2-1\" style=\"top:26px; left:179px;\" src=\"/122/static/_content/84-sub-2-1.png\" />\n          <img class=\"halfScale 84-sub-2-2\" style=\"top:170px; left:211px;\" src=\"/122/static/_content/84-sub-2-2.png\" />\n          <img class=\"halfScale 84-sub-2-3\" style=\"top:222px; left:2px;\" src=\"/122/static/_content/84-sub-2-3.png\" />\n\n          <!--Misc-->\n          <img class=\"halfScale 84-perc-2-2\" style=\"top:145px; left:260px;\" src=\"/122/static/_content/84-percent-2-2.png\" />\n          <img class=\"halfScale 84-perc-2-3\" style=\"top:196px; left:38px;\" src=\"/122/static/_content/84-percent-2-3.png\" />\n\n          <!--Numbers-->\n          <h1 class=\"abs paris2024B 84-no\"\n          style=\"top: 138px; left: 208px; font-size: 1.8em; font-weight:300; margin:0; color:#18bab0; padding:0; margin:0;\"\n          data-number='{\"to\": 100}' ></h1>\n          <h1 class=\"abs paris2024B 84-no\"\n          style=\"top: 189px; left: 1px; font-size: 1.8em; font-weight:300; margin:0; color:#18bab0; padding:0; margin:0;\"\n          data-number='{\"to\": 50}' ></h1>\n\n\n\n        </div>\n        \n\n        <!-- Circle3 -->\n        <div class=\"abs\" style=\"top:360px; left:352px\">\n\n          <img class=\"halfScaleC 84-image-3\" style=\"top:-93px; left:-21px;\" src=\"/122/static/_content/84-image-3.png\" />\n\n          <!--Line-->\n          <img class=\"halfScaleC 84-line-3-1\" style=\"top:115px; left:40px;\" src=\"/122/static/_content/84-line-3-1.png\" />\n          <img class=\"halfScaleC 84-line-3-2\" style=\"top:173px; left:141px;\" src=\"/122/static/_content/84-line-3-2.png\" />\n          <img class=\"halfScaleC 84-line-3-3\" style=\"top:123px; left:222px;\" src=\"/122/static/_content/84-line-3-3.png\" />\n          <!--sub-->\n          <img class=\"halfScale 84-sub-3-1\" style=\"top:152px; left:2px;\" src=\"/122/static/_content/84-sub-3-1.png\" />\n          <img class=\"halfScale 84-sub-3-2\" style=\"top:241px; left:144px;\" src=\"/122/static/_content/84-sub-3-2.png\" />\n          <img class=\"halfScale 84-sub-3-3\" style=\"top:168px; left:262px;\" src=\"/122/static/_content/84-sub-3-3.png\" />\n\n          <!--Misc-->\n          <img class=\"halfScale 84-perc-3-2\" style=\"top:142px; left:298px;\" src=\"/122/static/_content/84-percent-3-2.png\" />\n          <img class=\"halfScale 84-perc-3-3\" style=\"top:215px; left:180px;\" src=\"/122/static/_content/84-percent-3-3.png\" />\n\n          <!--Numbers-->\n          <h1 class=\"abs paris2024B 84-no\"\n          style=\"top: 118px; left: -1px; font-size: 1.8em; font-weight:300; margin:0; color:#5dbf8c; padding:0; margin:0;\"\n          data-number='{\"to\": 120}' ></h1>\n          <h1 class=\"abs paris2024B 84-no\"\n          style=\"top: 135px; left: 261px; font-size: 1.8em; font-weight:300; margin:0; color:#5dbf8c; padding:0; margin:0;\"\n          data-number='{\"to\": 50}' ></h1>\n          <h1 class=\"abs paris2024B 84-no\"\n          style=\"top: 208px; left: 143px; font-size: 1.8em; font-weight:300; margin:0; color:#5dbf8c; padding:0; margin:0;\"\n          data-number='{\"to\": 80}' ></h1>\n\n        </div>\n        \n\n        <!-- Circle4 -->\n        <div class=\"abs\" style=\"top:543px; left:32px\">\n\n          <img class=\"halfScaleC 84-image-4\" style=\"top:-94px; left:-92px;\" src=\"/122/static/_content/84-image-4.png\" />\n\n          <!--Line-->\n          <img class=\"halfScaleC 84-line-4-1\" style=\"top:69px; left:170px;\" src=\"/122/static/_content/84-line-4-1.png\" />\n          <img class=\"halfScaleC 84-line-4-2\" style=\"top:161px; left:135px;\" src=\"/122/static/_content/84-line-4-2.png\" />\n          <img class=\"halfScaleC 84-line-4-3\" style=\"top:153px; left:22px;\" src=\"/122/static/_content/84-line-4-3.png\" />\n          <!--sub-->\n          <img class=\"halfScale 84-sub-4-1\" style=\"top:91px; left:216px;\" src=\"/122/static/_content/84-sub-4-1.png\" />\n          <img class=\"halfScale 84-sub-4-2\" style=\"top:228px; left:166px;\" src=\"/122/static/_content/84-sub-4-2.png\" />\n          <img class=\"halfScale 84-sub-4-3\" style=\"top:219px; left:24px;\" src=\"/122/static/_content/84-sub-4-3.png\" />\n\n          <!--Misc-->\n          <img class=\"halfScale 84-perc-4-1\" style=\"top:65px; left:244px;\" src=\"/122/static/_content/84-percent-4-1.png\" />\n          <img class=\"halfScaleC 84-title-4-2\" style=\"top:190px; left:227px;\" src=\"/122/static/_content/84-title-4-2.png\" />\n\n          <!--Numbers-->\n          <h1 class=\"abs paris2024B 84-no\"\n          style=\"top: 58px; left: 213px; font-size: 1.8em; font-weight:300; margin:0; color:#f15f64; padding:0; margin:0;\"\n          data-number='{\"to\": 95}' ></h1>\n          <h1 class=\"abs paris2024B 84-no\"\n          style=\"top: 194px; left: 165px; font-size: 1.8em; font-weight:300; margin:0; color:#f15f64; padding:0; margin:0;\"\n          data-number='{\"to\": 4680, \"comma\":true}' ></h1>\n          <h1 class=\"abs paris2024B 84-no\"\n          style=\"top: 186px; left: 22px; font-size: 1.8em; font-weight:300; margin:0; color:#f15f64; padding:0; margin:0;\"\n          data-number='{\"to\": 1.5, \"decimals\":1, \"append\":\"m\"}' ></h1>\n\n        </div>\n\n\n\n        <!-- Circle5 -->\n        <div class=\"abs\" style=\"top:653px; left:384px\">\n\n          <img class=\"halfScaleC 84-image-5\" style=\"top:-92px; left:14px;\" src=\"/122/static/_content/84-image-5.png\" />\n\n          <!--Line-->\n          <img class=\"halfScaleC 84-line-5-1\" style=\"top:57px; left:80px;\" src=\"/122/static/_content/84-line-5-1.png\" />\n          <img class=\"halfScaleC 84-line-5-2\" style=\"top:118px; left:76px;\" src=\"/122/static/_content/84-line-5-2.png\" />\n          <!--sub-->\n          <img class=\"halfScale 84-sub-5-1\" style=\"top:80px; left:7px;\" src=\"/122/static/_content/84-sub-5-1.png\" />\n          <img class=\"halfScale 84-sub-5-2\" style=\"top:156px; left:36px;\" src=\"/122/static/_content/84-sub-5-2.png\" />\n\n          <!--Misc-->\n          <img class=\"halfScale 84-perc-5-2\" style=\"top:131px; left:70px;\" src=\"/122/static/_content/84-percent-5-2.png\" />\n          <img class=\"halfScale 84-title-5-1\" style=\"top:53px; left:64px;\" src=\"/122/static/_content/84-title-5-1.png\" />\n\n          <!--Numbers-->\n          <h1 class=\"abs paris2024B 84-no\"\n          style=\"top: 47px; left: 4px; font-size: 1.8em; font-weight:300; margin:0; color:#03425d; padding:0; margin:0;\"\n          data-number='{\"to\": 400}' ></h1>\n          <h1 class=\"abs paris2024B 84-no\"\n          style=\"top: 123px; left: 34px; font-size: 1.8em; font-weight:300; margin:0; color:#03425d; padding:0; margin:0;\"\n          data-number='{\"to\": 80, \"comma\":true}' ></h1>\n\n\n        </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n\n          pg84Anim = new TimelineMax();\n\n          // Circle 1\n          pg84Anim\n            .fromTo(cOf(\"84-image-1\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 0.8)\n            .fromTo(cOf(\"84-line-1-1\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 0.9)\n            .fromTo(cOf(\"84-line-1-2\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 0.9)\n            .fromTo(cOf(\"84-sub-1-1\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"84-sub-1-2\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"84-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"84-no\")[0]);}}, 1)\n            .fromTo(cOf(\"84-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"84-no\")[1]);}}, 1);\n\n          // Circle 2\n          pg84Anim\n            .fromTo(cOf(\"84-image-2\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 1.2)\n            .fromTo(cOf(\"84-line-2-1\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 1.3)\n            .fromTo(cOf(\"84-line-2-2\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 1.3)\n            .fromTo(cOf(\"84-line-2-3\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 1.3)\n            .fromTo(cOf(\"84-title-2-1\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.4)\n            .fromTo(cOf(\"84-sub-2-1\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.4)\n            .fromTo(cOf(\"84-sub-2-2\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.4)\n            .fromTo(cOf(\"84-perc-2-2\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.4)\n            .fromTo(cOf(\"84-perc-2-3\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.4)\n            .fromTo(cOf(\"84-sub-2-3\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.4)\n            .fromTo(cOf(\"84-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"84-no\")[2]);}}, 1.4)\n            .fromTo(cOf(\"84-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"84-no\")[3]);}}, 1.4);\n\n          // Circle 3\n          pg84Anim\n            .fromTo(cOf(\"84-image-3\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 1.6)\n            .fromTo(cOf(\"84-line-3-1\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 1.7)\n            .fromTo(cOf(\"84-line-3-2\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 1.7)\n            .fromTo(cOf(\"84-line-3-3\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 1.7)\n            .fromTo(cOf(\"84-sub-3-1\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.8)\n            .fromTo(cOf(\"84-sub-3-2\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.8)\n            .fromTo(cOf(\"84-perc-3-2\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.8)\n            .fromTo(cOf(\"84-perc-3-3\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.8)\n            .fromTo(cOf(\"84-sub-3-3\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.8)\n            .fromTo(cOf(\"84-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"84-no\")[4]);}}, 1.8)\n            .fromTo(cOf(\"84-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"84-no\")[5]);}}, 1.8)\n            .fromTo(cOf(\"84-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"84-no\")[6]);}}, 1.8);\n\n          // Circle 4\n          pg84Anim\n            .fromTo(cOf(\"84-image-4\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 2.0)\n            .fromTo(cOf(\"84-line-4-1\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 2.1)\n            .fromTo(cOf(\"84-line-4-2\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 2.1)\n            .fromTo(cOf(\"84-line-4-3\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 2,1)\n            .fromTo(cOf(\"84-sub-4-1\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"84-perc-4-1\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"84-sub-4-2\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"84-title-4-2\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"84-sub-4-3\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"84-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"84-no\")[7]);}}, 2.2)\n            .fromTo(cOf(\"84-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"84-no\")[8]);}}, 2.2)\n            .fromTo(cOf(\"84-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"84-no\")[9]);}}, 2.2);\n\n          // Circle 5\n          pg84Anim\n            .fromTo(cOf(\"84-image-5\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 2.4)\n            .fromTo(cOf(\"84-line-5-1\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 2.5)\n            .fromTo(cOf(\"84-line-5-2\"), 0.7, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.0)}, 2.5)\n            .fromTo(cOf(\"84-sub-5-1\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 2.6)\n            .fromTo(cOf(\"84-perc-5-2\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 2.6)\n            .fromTo(cOf(\"84-title-5-1\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 2.6)\n            .fromTo(cOf(\"84-sub-5-2\"), 0.8, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 2.6)\n            .fromTo(cOf(\"84-no\")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"84-no\")[10]);}}, 2.6)\n            .fromTo(cOf(\"84-no\")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"84-no\")[11]);}}, 2.6);\n\n\n        }\n\n        function onPageLeave() {\n\n          pg84Anim.stop();\n          resetNumbers(\"84-no\");\n\n        }\n      ",
    "searchText": "84  The last word  eg  Less more oe Less is mo  O  pic Village m y l r  e ne ration  Futu re  We look at the innovative ways that Paris 2024 is delivering more sustainable Games  1st  nning a l p  6,000  Olympic Games aligned with the Paris Agreement on climate change  people to be provided workplaces in residential and business district after the Games  Mo  pl  tic  reduction in carbon emissions compared to London 2012 and Rio 2016  Reducing, re n  nts, less  renewable energy to be used during the Games  50%  an g n ti  people to be provided apartments, with 25% for public housing  as  100%  pla e r  6,000  d reusi  120 organisations, including farmers, nutritionists and 200 athletes helped create the Paris 2024 Food Vision  ng  95  of competition venues are pre-existing or temporary  4,680m2 of solar panels installed on Aquatics Centre rooftop  80% hinking Ret mo  of new bike lanes added to the existing public transport network  80% of venues situated within 10km of the Olympic Village  ity bil  pieces of sports equipment rented or provided by sports federations  reduction in single-use plastic used in catering  of ingredients sourced from local agriculture production  %  400km 1.5m  50%"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 84,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg85.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "omegawatches.com  I N T R I B U T E T O PA R I S 2 0 2 4 The Speedmaster Chronoscope Paris 2024 is a reminder of the expert precision that OMEGA brings to the Olympic and Paralympic Games. Created in the colours of this summer's historic sporting competition, the design is crafted in stainless steel and features a commemorative medallion on the caseback. On the dial, a unique timing track is revealed, with tachymeter, pulsometer, and telemeter scales in a 1940s snail display. A sublime tool for measurement that celebrates RXU WUXVWHG UROH DV 2IƸFLDO 7LPHNHHSHU"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 85,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg86.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-VS61R66CNV" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "ZZuH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d/CA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dTE+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gck0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gqD2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "icNF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lGnO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "loeG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mLy2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n9S7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oEyU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tATK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tki5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y5zj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yREt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.2838baf67f869d05120f.js